/* eslint-disable */
import { gql } from 'graphql.macro';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /** 
 * The `DateTimeOffset` scalar type represents a date, time and offset from UTC.
   * `DateTimeOffset` expects timestamps to be formatted in accordance with the
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard.
 **/
  DateTimeOffset: string,
  /** 
 * The `Date` scalar type represents a year, month and day in accordance with the
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard.
 **/
  Date: string,
  /** 
 * The `DateTime` scalar type represents a date and time. `DateTime` expects
   * timestamps to be formatted in accordance with the
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard.
 **/
  DateTime: string,
  Decimal: any,
  /** The `Milliseconds` scalar type represents a period of time represented as the total number of milliseconds. */
  Milliseconds: any,
  /** The `Seconds` scalar type represents a period of time represented as the total number of seconds. */
  Seconds: any,
};

export enum ActionType {
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted'
}

/** Activity */
export type IActivity = {
  readonly __typename?: 'Activity',
  readonly actionTime?: Maybe<Scalars['DateTimeOffset']>,
  readonly actionType?: Maybe<ActionType>,
  readonly actorId?: Maybe<Scalars['String']>,
  readonly actorName?: Maybe<Scalars['String']>,
  readonly additionalData?: Maybe<IDictionaryOfStringandString>,
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly createdDateTime: Scalars['DateTimeOffset'],
  readonly delta?: Maybe<ReadonlyArray<Maybe<IChangeDetail>>>,
  readonly eTag?: Maybe<Scalars['String']>,
  readonly id: Scalars['String'],
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDateTime: Scalars['DateTimeOffset'],
  readonly ticketId?: Maybe<Scalars['String']>,
  readonly type?: Maybe<ActivityType>,
};

export enum ActivityType {
  Email = 'email',
  Conversation = 'conversation',
  PhoneCall = 'phoneCall',
  TicketChange = 'ticketChange'
}

export enum AgeFilterOption {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months'
}

export type IAllExtensions = {
  readonly __typename?: 'AllExtensions',
  readonly teamsCehExtension?: Maybe<ITeamsCehExtension>,
};

export enum AriaKeyClientType {
  Default = 'default',
  Android = 'android',
  Desktop = 'desktop',
  IOs = 'iOS',
  Web = 'web'
}

export enum AssignmentConstants {
  Unassigned = 'Unassigned'
}

export enum AssignmentFilterOption {
  AssignedToMe = 'Assigned to me',
  Unassigned = 'Unassigned'
}

export type IChangeDetail = {
  readonly __typename?: 'ChangeDetail',
  readonly currentValue: Scalars['String'],
  readonly previousValue: Scalars['String'],
  readonly propertyPath: Scalars['String'],
};

export type ICreateEmailAddressInput = {
  readonly address: Scalars['String'],
  readonly name: Scalars['String'],
  readonly displayName?: Maybe<Scalars['String']>,
};

export type ICreateModalityConfigurationInput = {
  readonly groupId: Scalars['String'],
  readonly channelId: Scalars['String'],
  readonly modalityType?: Maybe<Modality>,
  readonly notifyMembers?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly notifyAllMembers?: Maybe<Scalars['Boolean']>,
  readonly proxyAddresses?: Maybe<ReadonlyArray<Maybe<ICreateEmailAddressInput>>>,
  readonly autoReplyBody: Scalars['String'],
  readonly state?: Maybe<ModalityState>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
};

/** ResponseTeamSettings */
export type ICreateResponseTeamSettingsInput = {
  readonly userObjectId: Scalars['String'],
  readonly modalityType?: Maybe<Modality>,
  readonly notify?: Maybe<Scalars['Boolean']>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
};

export type ICreateTicketInput = {
  readonly groupId: Scalars['String'],
  readonly channelId: Scalars['String'],
  readonly teamsConversationId?: Maybe<Scalars['String']>,
  readonly title: Scalars['String'],
  readonly state?: Maybe<Scalars['String']>,
  readonly priority?: Maybe<Priority>,
  readonly createdBy: Scalars['String'],
  readonly lastModifiedBy?: Maybe<Scalars['String']>,
  readonly assignedToObjectId?: Maybe<Scalars['String']>,
  readonly assignedToDisplayName?: Maybe<Scalars['String']>,
  readonly assignedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly customerDisplayName?: Maybe<Scalars['String']>,
  readonly customerAddress?: Maybe<Scalars['String']>,
  readonly lastCommunicationAt?: Maybe<Scalars['DateTimeOffset']>,
  readonly attachmentFolderId?: Maybe<Scalars['String']>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
};

/** UserNotificationSettings */
export type ICreateUserNotificationSettingsInput = {
  readonly userObjectId: Scalars['String'],
  readonly modalityType?: Maybe<Modality>,
  readonly notifyOnTicketChange: Scalars['Boolean'],
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
};





export type IDictionaryOfStringandString = {
  readonly __typename?: 'DictionaryOfStringandString',
  readonly count?: Maybe<Scalars['Int']>,
  readonly item?: Maybe<Scalars['String']>,
  readonly keys?: Maybe<IKeyCollectionOfStringandString>,
  readonly values?: Maybe<IValueCollectionOfStringandString>,
};

export type IEmailAddress = {
  readonly __typename?: 'EmailAddress',
  readonly address: Scalars['String'],
  readonly displayName?: Maybe<Scalars['String']>,
  readonly name: Scalars['String'],
};

export type IEmailMessage = {
  readonly __typename?: 'EmailMessage',
  readonly allExtensions?: Maybe<IAllExtensions>,
  readonly body?: Maybe<IMessageBody>,
  readonly bodyPreview?: Maybe<Scalars['String']>,
  readonly ccRecipients?: Maybe<ReadonlyArray<Maybe<IRecipient>>>,
  readonly conversationId?: Maybe<Scalars['String']>,
  readonly from?: Maybe<IRecipient>,
  readonly hasAttachments?: Maybe<Scalars['Boolean']>,
  readonly id?: Maybe<Scalars['String']>,
  readonly internetMessageId?: Maybe<Scalars['String']>,
  readonly isDraft?: Maybe<Scalars['Boolean']>,
  readonly isRead?: Maybe<Scalars['Boolean']>,
  readonly lastModifiedDateTime?: Maybe<Scalars['DateTimeOffset']>,
  readonly receivedDateTime?: Maybe<Scalars['DateTimeOffset']>,
  readonly sender?: Maybe<IRecipient>,
  readonly sentDateTime?: Maybe<Scalars['DateTimeOffset']>,
  readonly singleValueExtendedProperties?: Maybe<ReadonlyArray<Maybe<ISingleValueExtendedProperty>>>,
  readonly subject?: Maybe<Scalars['String']>,
  readonly toRecipients?: Maybe<ReadonlyArray<Maybe<IRecipient>>>,
  readonly webLink?: Maybe<Scalars['String']>,
};

export type IEmailModality = {
  readonly __typename?: 'EmailModality',
  readonly name?: Maybe<Scalars['String']>,
  readonly alias?: Maybe<Scalars['String']>,
  readonly aliasWithoutPrefixAndSuffix?: Maybe<Scalars['String']>,
  readonly domain?: Maybe<Scalars['String']>,
  readonly notifyUsers?: Maybe<ReadonlyArray<Maybe<IUser>>>,
  readonly notifyAllUsers: Scalars['Boolean'],
  readonly autoReplyText?: Maybe<Scalars['String']>,
};

export type IEmailModalityInput = {
  readonly displayName?: Maybe<Scalars['String']>,
  readonly alias?: Maybe<Scalars['String']>,
  readonly aliasWithoutPrefixAndSuffix?: Maybe<Scalars['String']>,
  readonly domain?: Maybe<Scalars['String']>,
  readonly notifyUsers?: Maybe<ReadonlyArray<Maybe<IUserInput>>>,
  readonly notifyAllUsers: Scalars['Boolean'],
  readonly autoReplyText?: Maybe<Scalars['String']>,
};

export enum EmailResponseActions {
  Createreply = 'createreply',
  Createreplyall = 'createreplyall',
  Createforward = 'createforward'
}

export enum ErrorCode {
  SdsError = 'sdsError',
  NotFound = 'notFound',
  NotSupported = 'notSupported',
  UploadLinkExpired = 'uploadLinkExpired',
  AttachmentTooLarge = 'attachmentTooLarge',
  UploadMoreContent = 'uploadMoreContent',
  UploadCompleted = 'uploadCompleted',
  UploadDataMissing = 'uploadDataMissing'
}

/** Group */
export type IExchangeGroup = {
  readonly __typename?: 'ExchangeGroup',
  readonly allowExternalSenders?: Maybe<Scalars['Boolean']>,
  readonly emailAddress?: Maybe<Scalars['String']>,
  readonly groupObjectId?: Maybe<Scalars['String']>,
  readonly id?: Maybe<Scalars['String']>,
  readonly proxyAddresses?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
};

export type IFilterOption = {
  readonly __typename?: 'FilterOption',
  readonly stateFilterOption: ReadonlyArray<Maybe<StateFilterOption>>,
  readonly ageFilterOption: ReadonlyArray<Maybe<AgeFilterOption>>,
  readonly assignmentFilterOption: ReadonlyArray<Maybe<AssignmentFilterOption>>,
  readonly followFilterOption: ReadonlyArray<Maybe<FollowFilterOption>>,
};

export type IFilterOptionInput = {
  readonly stateFilterOption: ReadonlyArray<Maybe<StateFilterOption>>,
  readonly ageFilterOption: ReadonlyArray<Maybe<AgeFilterOption>>,
  readonly assignmentFilterOption: ReadonlyArray<Maybe<AssignmentFilterOption>>,
  readonly followFilterOption: ReadonlyArray<Maybe<FollowFilterOption>>,
};

export enum FollowFilterOption {
  Following = 'Messages I\'m following'
}

export type IGetStartedWizardState = {
  readonly __typename?: 'GetStartedWizardState',
  readonly isActive: Scalars['Boolean'],
  readonly draftEmailModality: IEmailModality,
  readonly draftModalityType: Scalars['String'],
  readonly emailSetupMethod: Scalars['String'],
  readonly isFinished: Scalars['Boolean'],
  readonly step: Scalars['Int'],
  readonly ringId: Scalars['String'],
  readonly configuredEmails: ReadonlyArray<Maybe<Scalars['String']>>,
  readonly configuredNotifications: ReadonlyArray<Maybe<Scalars['String']>>,
};

export type IGetStartedWizardStateInput = {
  readonly isActive: Scalars['Boolean'],
  readonly draftModalityType: Scalars['String'],
  readonly draftEmailModality: IEmailModalityInput,
  readonly isFinished: Scalars['Boolean'],
  readonly step: Scalars['Int'],
  readonly ringId: Scalars['String'],
  readonly configuredEmails: ReadonlyArray<Maybe<Scalars['String']>>,
  readonly configuredNotifications: ReadonlyArray<Maybe<Scalars['String']>>,
};

/** Represents a page of entities as well as metadata to help retrieve next page */
export type IGraphPageResultOfActivity = {
  readonly __typename?: 'GraphPageResultOfActivity',
  readonly items: ReadonlyArray<Maybe<IActivity>>,
  readonly pageInfo: IPageInfo,
};

/** Represents a page of entities as well as metadata to help retrieve next page */
export type IGraphPageResultOfModalityConfiguration = {
  readonly __typename?: 'GraphPageResultOfModalityConfiguration',
  readonly items: ReadonlyArray<Maybe<IModalityConfiguration>>,
  readonly pageInfo: IPageInfo,
};

/** Represents a page of entities as well as metadata to help retrieve next page */
export type IGraphPageResultOfRecipientDsApi = {
  readonly __typename?: 'GraphPageResultOfRecipientDsApi',
  readonly items: ReadonlyArray<Maybe<IRecipientDsApi>>,
  readonly pageInfo: IPageInfo,
};

/** Represents a page of entities as well as metadata to help retrieve next page */
export type IGraphPageResultOfResponseTeamSettings = {
  readonly __typename?: 'GraphPageResultOfResponseTeamSettings',
  readonly items: ReadonlyArray<Maybe<IResponseTeamSettings>>,
  readonly pageInfo: IPageInfo,
};

/** Represents a page of entities as well as metadata to help retrieve next page */
export type IGraphPageResultOfTicket = {
  readonly __typename?: 'GraphPageResultOfTicket',
  readonly items: ReadonlyArray<Maybe<ITicket>>,
  readonly pageInfo: IPageInfo,
};

/** Represents a page of entities as well as metadata to help retrieve next page */
export type IGraphPageResultOfTupleOfStringandUri = {
  readonly __typename?: 'GraphPageResultOfTupleOfStringandUri',
  readonly items: ReadonlyArray<Maybe<ITupleOfStringandUri>>,
  readonly pageInfo: IPageInfo,
};

/** Represents a page of entities as well as metadata to help retrieve next page */
export type IGraphPageResultOfUserNotificationSettings = {
  readonly __typename?: 'GraphPageResultOfUserNotificationSettings',
  readonly items: ReadonlyArray<Maybe<IUserNotificationSettings>>,
  readonly pageInfo: IPageInfo,
};

export type IGroup = {
  readonly __typename?: 'Group',
  readonly allowExternalSenders?: Maybe<Scalars['Boolean']>,
  readonly classification?: Maybe<Scalars['String']>,
  readonly createdDateTime?: Maybe<Scalars['Date']>,
  readonly description?: Maybe<Scalars['String']>,
  readonly displayName?: Maybe<Scalars['String']>,
  readonly groupTypes?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly id?: Maybe<Scalars['String']>,
  readonly mail?: Maybe<Scalars['String']>,
  readonly mailEnabled?: Maybe<Scalars['Boolean']>,
  readonly mailNickname?: Maybe<Scalars['String']>,
  readonly members?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly membershipRuleProcessingState?: Maybe<Scalars['String']>,
  readonly owners?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly proxyAddresses?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly renewedDateTime?: Maybe<Scalars['Date']>,
  readonly resourceProvisioningOptions?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly securityEnabled?: Maybe<Scalars['Boolean']>,
  readonly visibility?: Maybe<Scalars['String']>,
};

export enum HttpStatusCode {
  Continue = 'continue',
  SwitchingProtocols = 'switchingProtocols',
  Processing = 'processing',
  EarlyHints = 'earlyHints',
  OK = 'oK',
  Created = 'created',
  Accepted = 'accepted',
  NonAuthoritativeInformation = 'nonAuthoritativeInformation',
  NoContent = 'noContent',
  ResetContent = 'resetContent',
  PartialContent = 'partialContent',
  MultiStatus = 'multiStatus',
  AlreadyReported = 'alreadyReported',
  IMUsed = 'iMUsed',
  Ambiguous = 'ambiguous',
  Moved = 'moved',
  Redirect = 'redirect',
  RedirectMethod = 'redirectMethod',
  NotModified = 'notModified',
  UseProxy = 'useProxy',
  Unused = 'unused',
  TemporaryRedirect = 'temporaryRedirect',
  PermanentRedirect = 'permanentRedirect',
  BadRequest = 'badRequest',
  Unauthorized = 'unauthorized',
  PaymentRequired = 'paymentRequired',
  Forbidden = 'forbidden',
  NotFound = 'notFound',
  MethodNotAllowed = 'methodNotAllowed',
  NotAcceptable = 'notAcceptable',
  ProxyAuthenticationRequired = 'proxyAuthenticationRequired',
  RequestTimeout = 'requestTimeout',
  Conflict = 'conflict',
  Gone = 'gone',
  LengthRequired = 'lengthRequired',
  PreconditionFailed = 'preconditionFailed',
  RequestEntityTooLarge = 'requestEntityTooLarge',
  RequestUriTooLong = 'requestUriTooLong',
  UnsupportedMediaType = 'unsupportedMediaType',
  RequestedRangeNotSatisfiable = 'requestedRangeNotSatisfiable',
  ExpectationFailed = 'expectationFailed',
  MisdirectedRequest = 'misdirectedRequest',
  UnprocessableEntity = 'unprocessableEntity',
  Locked = 'locked',
  FailedDependency = 'failedDependency',
  UpgradeRequired = 'upgradeRequired',
  PreconditionRequired = 'preconditionRequired',
  TooManyRequests = 'tooManyRequests',
  RequestHeaderFieldsTooLarge = 'requestHeaderFieldsTooLarge',
  UnavailableForLegalReasons = 'unavailableForLegalReasons',
  InternalServerError = 'internalServerError',
  NotImplemented = 'notImplemented',
  BadGateway = 'badGateway',
  ServiceUnavailable = 'serviceUnavailable',
  GatewayTimeout = 'gatewayTimeout',
  HttpVersionNotSupported = 'httpVersionNotSupported',
  VariantAlsoNegotiates = 'variantAlsoNegotiates',
  InsufficientStorage = 'insufficientStorage',
  LoopDetected = 'loopDetected',
  NotExtended = 'notExtended',
  NetworkAuthenticationRequired = 'networkAuthenticationRequired'
}

export type IKeyCollectionOfStringandString = {
  readonly __typename?: 'KeyCollectionOfStringandString',
  readonly count?: Maybe<Scalars['Int']>,
};

export type IMessageBody = {
  readonly __typename?: 'MessageBody',
  readonly content?: Maybe<Scalars['String']>,
  readonly contentType?: Maybe<Scalars['String']>,
};


export enum Modality {
  None = 'none',
  Email = 'email',
  CallQueue = 'callQueue'
}

export type IModalityConfiguration = {
  readonly __typename?: 'ModalityConfiguration',
  readonly autoReplyBody: Scalars['String'],
  readonly channelId: Scalars['String'],
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly createdDateTime: Scalars['DateTimeOffset'],
  readonly eTag?: Maybe<Scalars['String']>,
  readonly groupId: Scalars['String'],
  readonly id: Scalars['String'],
  readonly itemId: Scalars['String'],
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDateTime: Scalars['DateTimeOffset'],
  readonly modalityType?: Maybe<Modality>,
  readonly notifyAllMembers?: Maybe<Scalars['Boolean']>,
  readonly notifyMembers?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly proxyAddresses?: Maybe<ReadonlyArray<Maybe<IEmailAddress>>>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly state?: Maybe<ModalityState>,
};

export enum ModalityState {
  NotStarted = 'notStarted',
  GroupRetrieved = 'groupRetrieved',
  GroupProxyAddressUpdated = 'groupProxyAddressUpdated',
  AllowExternalSenderEnabled = 'allowExternalSenderEnabled',
  EmailProcessorFeatureFlagSet = 'emailProcessorFeatureFlagSet',
  Done = 'done'
}

/** Schema for mutations. */
export type IMutation = {
  readonly __typename?: 'Mutation',
  readonly addpermission?: Maybe<Scalars['Boolean']>,
  readonly cancelupload?: Maybe<Scalars['Boolean']>,
  readonly configureModality?: Maybe<IModalityConfiguration>,
  readonly createattachment?: Maybe<Scalars['String']>,
  readonly createConversationActivity?: Maybe<Scalars['Boolean']>,
  readonly createResponseTeamSettings?: Maybe<IResponseTeamSettings>,
  readonly createTicket?: Maybe<ITicket>,
  readonly createUserNotificationSettings?: Maybe<IUserNotificationSettings>,
  readonly deleteAllModalities?: Maybe<Scalars['Boolean']>,
  readonly deleteModality?: Maybe<Scalars['Boolean']>,
  readonly deleteResponseTeamSettings?: Maybe<Scalars['Boolean']>,
  readonly deleteResponseTeamSettingsCollection?: Maybe<Scalars['Boolean']>,
  readonly deleteTicket?: Maybe<Scalars['Boolean']>,
  readonly deleteUserNotificationSettings?: Maybe<Scalars['Boolean']>,
  readonly followTicket?: Maybe<Scalars['Boolean']>,
  readonly removepermission?: Maybe<Scalars['Boolean']>,
  readonly respondToEmail?: Maybe<Scalars['String']>,
  readonly sendDraftEmail?: Maybe<Scalars['Boolean']>,
  readonly unfollowTicket?: Maybe<Scalars['Boolean']>,
  readonly updateModalityConfiguration?: Maybe<IModalityConfiguration>,
  readonly updateResponseTeamSettings?: Maybe<IResponseTeamSettings>,
  readonly updateTicket?: Maybe<ITicket>,
  readonly updateTickets?: Maybe<ReadonlyArray<Maybe<ITicket>>>,
  readonly updateUserNotificationSetting?: Maybe<IUserNotificationSettings>,
  readonly uploadattachment?: Maybe<IUploadResponse>,
  readonly setGetStartedWizardState?: Maybe<IGetStartedWizardState>,
  readonly setTicketListState?: Maybe<ITicketListState>,
  readonly setTicketListSelectionState?: Maybe<ITicketListSelectionState>,
  readonly setUserSettings?: Maybe<IUserSettings>,
  readonly setSendAsState?: Maybe<ISendAsState>,
};


/** Schema for mutations. */
export type IMutationAddpermissionArgs = {
  modernGroupSmtp: Scalars['String'],
  userSmtp: Scalars['String']
};


/** Schema for mutations. */
export type IMutationCanceluploadArgs = {
  groupId: Scalars['String'],
  attachmentUploadId: Scalars['String']
};


/** Schema for mutations. */
export type IMutationConfigureModalityArgs = {
  config: ICreateModalityConfigurationInput
};


/** Schema for mutations. */
export type IMutationCreateattachmentArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  channelName: Scalars['String'],
  ticketId: Scalars['String'],
  attachmentName: Scalars['String'],
  attachmentSize: Scalars['Int']
};


/** Schema for mutations. */
export type IMutationCreateConversationActivityArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String'],
  actor: Scalars['String']
};


/** Schema for mutations. */
export type IMutationCreateResponseTeamSettingsArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  newResponseTeamSettings: ICreateResponseTeamSettingsInput,
  skipItemEventProcessor?: Maybe<Scalars['Boolean']>
};


/** Schema for mutations. */
export type IMutationCreateTicketArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  newTicket: ICreateTicketInput,
  skipItemEventProcessor?: Maybe<Scalars['Boolean']>
};


/** Schema for mutations. */
export type IMutationCreateUserNotificationSettingsArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  newUserNotificationSettings: ICreateUserNotificationSettingsInput
};


/** Schema for mutations. */
export type IMutationDeleteAllModalitiesArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String']
};


/** Schema for mutations. */
export type IMutationDeleteModalityArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  modalityId: Scalars['String']
};


/** Schema for mutations. */
export type IMutationDeleteResponseTeamSettingsArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String'],
  skipItemEventProcessor?: Maybe<Scalars['Boolean']>
};


/** Schema for mutations. */
export type IMutationDeleteResponseTeamSettingsCollectionArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String']
};


/** Schema for mutations. */
export type IMutationDeleteTicketArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String'],
  skipItemEventProcessor?: Maybe<Scalars['Boolean']>
};


/** Schema for mutations. */
export type IMutationDeleteUserNotificationSettingsArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String']
};


/** Schema for mutations. */
export type IMutationFollowTicketArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String']
};


/** Schema for mutations. */
export type IMutationRemovepermissionArgs = {
  modernGroupSmtp: Scalars['String'],
  userSmtp: Scalars['String']
};


/** Schema for mutations. */
export type IMutationRespondToEmailArgs = {
  groupId: Scalars['String'],
  itemId: Scalars['String'],
  action: EmailResponseActions
};


/** Schema for mutations. */
export type IMutationSendDraftEmailArgs = {
  groupId: Scalars['String'],
  itemId: Scalars['String']
};


/** Schema for mutations. */
export type IMutationUnfollowTicketArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String']
};


/** Schema for mutations. */
export type IMutationUpdateModalityConfigurationArgs = {
  updatedModality: IUpdateModalityConfigurationInput
};


/** Schema for mutations. */
export type IMutationUpdateResponseTeamSettingsArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String'],
  updatedResponseTeamSettings: IUpdateResponseTeamSettingsInput,
  skipItemEventProcessor?: Maybe<Scalars['Boolean']>
};


/** Schema for mutations. */
export type IMutationUpdateTicketArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String'],
  updatedTicket: IUpdateTicketInput,
  skipItemEventProcessor?: Maybe<Scalars['Boolean']>
};


/** Schema for mutations. */
export type IMutationUpdateTicketsArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketIds: ReadonlyArray<Maybe<Scalars['String']>>,
  updatedTickets: ReadonlyArray<Maybe<IUpdateTicketInput>>,
  skipItemEventProcessor?: Maybe<Scalars['Boolean']>
};


/** Schema for mutations. */
export type IMutationUpdateUserNotificationSettingArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String'],
  updatedUserNotificationSettings: IUpdateUserNotificationSettingsInput
};


/** Schema for mutations. */
export type IMutationUploadattachmentArgs = {
  groupId: Scalars['String'],
  uploadRecordId: Scalars['String'],
  content: Scalars['String']
};


/** Schema for mutations. */
export type IMutationSetGetStartedWizardStateArgs = {
  wizardState?: Maybe<IGetStartedWizardStateInput>
};


/** Schema for mutations. */
export type IMutationSetTicketListStateArgs = {
  state?: Maybe<ITicketListStateInput>
};


/** Schema for mutations. */
export type IMutationSetTicketListSelectionStateArgs = {
  state?: Maybe<ITicketListSelectionStateInput>
};


/** Schema for mutations. */
export type IMutationSetUserSettingsArgs = {
  userSettings: IUserSettingsInput
};


/** Schema for mutations. */
export type IMutationSetSendAsStateArgs = {
  sendAsState: ISendAsStateInput
};

/** Contains metadata about the result set to help clients paginate */
export type IPageInfo = {
  readonly __typename?: 'PageInfo',
  /** Represents an opaque string that the client may use to retrieve the next page of results. */
  readonly nextLink?: Maybe<Scalars['String']>,
  /** Represents an opaque string that the client may use to retrieve the next page of results. */
  readonly skipToken?: Maybe<Scalars['String']>,
};

export enum Priority {
  None = 'none',
  Low = 'low',
  Medium = 'medium',
  High = 'high'
}

/** ProfilePicture */
export type IProfilePicture = {
  readonly __typename?: 'ProfilePicture',
  readonly id?: Maybe<Scalars['String']>,
  readonly upn?: Maybe<Scalars['String']>,
  readonly value: Scalars['String'],
};

/** Schema for queries. */
export type IQuery = {
  readonly __typename?: 'Query',
  readonly acceptedDomains?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly attachments?: Maybe<IGraphPageResultOfTupleOfStringandUri>,
  readonly channelModalities?: Maybe<IGraphPageResultOfModalityConfiguration>,
  readonly defaultDomain?: Maybe<Scalars['String']>,
  readonly delegateListLinks?: Maybe<IGraphPageResultOfRecipientDsApi>,
  readonly delegateListLinksBL?: Maybe<IGraphPageResultOfRecipientDsApi>,
  readonly ensureRecipientPermissionIsSet?: Maybe<Scalars['Boolean']>,
  readonly getAriaKey?: Maybe<Scalars['String']>,
  readonly getCurrentUsersOwnedGroups?: Maybe<ReadonlyArray<Maybe<IGroup>>>,
  readonly getEmailsByTicketId?: Maybe<ReadonlyArray<Maybe<IEmailMessage>>>,
  readonly getGroup?: Maybe<IExchangeGroup>,
  readonly getMessageHtml?: Maybe<Scalars['String']>,
  readonly getpermission?: Maybe<Scalars['Boolean']>,
  readonly getTeamInfo?: Maybe<ITeamInfo>,
  readonly getUsersByIds?: Maybe<ReadonlyArray<Maybe<IUser>>>,
  readonly responseTeamSetting?: Maybe<IResponseTeamSettings>,
  readonly responseTeamSettings?: Maybe<IGraphPageResultOfResponseTeamSettings>,
  readonly searchTeamMembers?: Maybe<ReadonlyArray<Maybe<IUser>>>,
  readonly testSmtpAvailability?: Maybe<ISmtpAvailability>,
  readonly testSmtpAvailabilityStatus?: Maybe<ISmtpAvailabilityStatus>,
  readonly ticket?: Maybe<ITicket>,
  readonly ticketActivities?: Maybe<IGraphPageResultOfActivity>,
  readonly tickets?: Maybe<IGraphPageResultOfTicket>,
  readonly ticketsWatermark?: Maybe<Scalars['DateTimeOffset']>,
  readonly userNotificationSetting?: Maybe<IUserNotificationSettings>,
  readonly userNotificationSettings?: Maybe<IGraphPageResultOfUserNotificationSettings>,
  readonly userProfilePicture?: Maybe<IProfilePicture>,
  readonly userProfilePictureById?: Maybe<IProfilePicture>,
  readonly userProfilePictures?: Maybe<ReadonlyArray<Maybe<IProfilePicture>>>,
  readonly userProfilePicturesByIds?: Maybe<ReadonlyArray<Maybe<IProfilePicture>>>,
  readonly getGetStartedWizardState?: Maybe<IGetStartedWizardState>,
  readonly ticketListState?: Maybe<ITicketListState>,
  readonly ticketListSelectionState?: Maybe<ITicketListSelectionState>,
  readonly userSettings?: Maybe<IUserSettings>,
  readonly sendAsState?: Maybe<ISendAsState>,
};


/** Schema for queries. */
export type IQueryAttachmentsArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String']
};


/** Schema for queries. */
export type IQueryChannelModalitiesArgs = {
  groupId: Scalars['String'],
  channelId?: Maybe<Scalars['String']>,
  top?: Maybe<Scalars['Int']>,
  createIfNotExist?: Maybe<Scalars['Boolean']>
};


/** Schema for queries. */
export type IQueryDelegateListLinksArgs = {
  objectId: Scalars['String']
};


/** Schema for queries. */
export type IQueryDelegateListLinksBlArgs = {
  objectId: Scalars['String']
};


/** Schema for queries. */
export type IQueryEnsureRecipientPermissionIsSetArgs = {
  modernGroupSmtp: Scalars['String'],
  userSmtp: Scalars['String']
};


/** Schema for queries. */
export type IQueryGetAriaKeyArgs = {
  clientType: AriaKeyClientType
};


/** Schema for queries. */
export type IQueryGetEmailsByTicketIdArgs = {
  groupId: Scalars['String'],
  ticketId: Scalars['String'],
  top?: Maybe<Scalars['Int']>
};


/** Schema for queries. */
export type IQueryGetGroupArgs = {
  groupId: Scalars['String']
};


/** Schema for queries. */
export type IQueryGetMessageHtmlArgs = {
  itemId: Scalars['String'],
  groupId: Scalars['String']
};


/** Schema for queries. */
export type IQueryGetpermissionArgs = {
  modernGroupSmtp: Scalars['String'],
  userSmtp: Scalars['String']
};


/** Schema for queries. */
export type IQueryGetTeamInfoArgs = {
  groupId: Scalars['String'],
  displayName?: Maybe<Scalars['String']>
};


/** Schema for queries. */
export type IQueryGetUsersByIdsArgs = {
  userIds: ReadonlyArray<Maybe<Scalars['String']>>,
  useAppToken?: Maybe<Scalars['Boolean']>
};


/** Schema for queries. */
export type IQueryResponseTeamSettingArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String']
};


/** Schema for queries. */
export type IQueryResponseTeamSettingsArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  filter?: Maybe<Scalars['String']>,
  sortBy?: Maybe<Scalars['String']>,
  top?: Maybe<Scalars['Int']>,
  skipToken?: Maybe<Scalars['String']>
};


/** Schema for queries. */
export type IQuerySearchTeamMembersArgs = {
  teamId: Scalars['String'],
  top: Scalars['Int'],
  search: Scalars['String']
};


/** Schema for queries. */
export type IQueryTestSmtpAvailabilityArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  name: Scalars['String'],
  domain: Scalars['String']
};


/** Schema for queries. */
export type IQueryTestSmtpAvailabilityStatusArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  name: Scalars['String'],
  domain: Scalars['String']
};


/** Schema for queries. */
export type IQueryTicketArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String']
};


/** Schema for queries. */
export type IQueryTicketActivitiesArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String'],
  filter?: Maybe<Scalars['String']>,
  sortBy?: Maybe<Scalars['String']>,
  top?: Maybe<Scalars['Int']>,
  skipToken?: Maybe<Scalars['String']>
};


/** Schema for queries. */
export type IQueryTicketsArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  filter?: Maybe<Scalars['String']>,
  sortBy?: Maybe<Scalars['String']>,
  top?: Maybe<Scalars['Int']>,
  skipToken?: Maybe<Scalars['String']>
};


/** Schema for queries. */
export type IQueryTicketsWatermarkArgs = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  lastKnownDateTime?: Maybe<Scalars['String']>
};


/** Schema for queries. */
export type IQueryUserNotificationSettingArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String']
};


/** Schema for queries. */
export type IQueryUserNotificationSettingsArgs = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  filter?: Maybe<Scalars['String']>,
  sortBy?: Maybe<Scalars['String']>,
  top?: Maybe<Scalars['Int']>,
  skipToken?: Maybe<Scalars['String']>
};


/** Schema for queries. */
export type IQueryUserProfilePictureArgs = {
  upn: Scalars['String'],
  displayName: Scalars['String']
};


/** Schema for queries. */
export type IQueryUserProfilePictureByIdArgs = {
  id: Scalars['String'],
  displayName: Scalars['String']
};


/** Schema for queries. */
export type IQueryUserProfilePicturesArgs = {
  emailAddresses: ReadonlyArray<Maybe<IQueryEmailAddressInput>>
};


/** Schema for queries. */
export type IQueryUserProfilePicturesByIdsArgs = {
  ids: ReadonlyArray<Maybe<Scalars['String']>>,
  displayNames: ReadonlyArray<Maybe<Scalars['String']>>
};

export type IQueryEmailAddressInput = {
  readonly address: Scalars['String'],
  readonly name: Scalars['String'],
  readonly displayName?: Maybe<Scalars['String']>,
};

export enum Reason {
  Unknown = 'unknown',
  Available = 'available',
  NotAvailable = 'notAvailable',
  BadDomain = 'badDomain',
  InvalidSmtpAddress = 'invalidSmtpAddress',
  NameMissingPrefixSuffix = 'nameMissingPrefixSuffix',
  NameContainsBlockedWord = 'nameContainsBlockedWord'
}

export type IRecipient = {
  readonly __typename?: 'Recipient',
  readonly emailAddress?: Maybe<IEmailAddress>,
};

export type IRecipientDsApi = {
  readonly __typename?: 'RecipientDsApi',
  readonly displayName?: Maybe<Scalars['String']>,
  readonly emailAddresses?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly exchangeObjectId?: Maybe<Scalars['String']>,
  readonly exchangeVersion?: Maybe<Scalars['String']>,
  readonly externalDirectoryObjectId?: Maybe<Scalars['String']>,
  readonly guid?: Maybe<Scalars['String']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly netID?: Maybe<Scalars['String']>,
  readonly objectId?: Maybe<Scalars['String']>,
  readonly prefixedIdentity?: Maybe<Scalars['String']>,
  readonly primarySmtpAddress?: Maybe<Scalars['String']>,
  readonly recipientType?: Maybe<Scalars['String']>,
  readonly recipientTypeDetails?: Maybe<Scalars['String']>,
  readonly sid?: Maybe<Scalars['String']>,
  readonly userPrincipalName?: Maybe<Scalars['String']>,
  readonly windowsLiveID?: Maybe<Scalars['String']>,
};

/** ResponseTeamSettings */
export type IResponseTeamSettings = {
  readonly __typename?: 'ResponseTeamSettings',
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly createdDateTime: Scalars['DateTimeOffset'],
  readonly eTag?: Maybe<Scalars['String']>,
  readonly id: Scalars['String'],
  readonly itemId: Scalars['String'],
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDateTime: Scalars['DateTimeOffset'],
  readonly modalityType?: Maybe<Modality>,
  readonly notify?: Maybe<Scalars['Boolean']>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly userObjectId: Scalars['String'],
};


export type ISendAsState = {
  readonly __typename?: 'SendAsState',
  readonly timeSet?: Maybe<Scalars['DateTimeOffset']>,
};

export type ISendAsStateInput = {
  readonly timeSet: Scalars['DateTimeOffset'],
};

export type ISingleValueExtendedProperty = {
  readonly __typename?: 'SingleValueExtendedProperty',
  readonly propertyId?: Maybe<Scalars['String']>,
  readonly value?: Maybe<Scalars['String']>,
};

export type ISmtpAvailability = {
  readonly __typename?: 'SmtpAvailability',
  readonly displayName?: Maybe<Scalars['String']>,
  readonly prefix?: Maybe<Scalars['String']>,
  readonly status?: Maybe<Reason>,
  readonly suffix?: Maybe<Scalars['String']>,
};

export type ISmtpAvailabilityStatus = {
  readonly __typename?: 'SmtpAvailabilityStatus',
  readonly displayName?: Maybe<Scalars['String']>,
  readonly prefix?: Maybe<Scalars['String']>,
  readonly state?: Maybe<Status>,
  readonly subState?: Maybe<SubStatus>,
  readonly suffix?: Maybe<Scalars['String']>,
};

export enum StateFilterOption {
  New = 'New',
  Active = 'Active',
  Closed = 'Closed'
}

export enum Status {
  Unknown = 'unknown',
  Available = 'available',
  NotAvailable = 'notAvailable'
}

export enum SubStatus {
  CanCreateNewEmail = 'canCreateNewEmail',
  TakeOverPossibleFromAnotherGroup = 'takeOverPossibleFromAnotherGroup',
  CurrentGroupUnused = 'currentGroupUnused',
  UsedByCurrentModality = 'usedByCurrentModality',
  InvalidSmtpAddress = 'invalidSmtpAddress',
  NameContainsBlockedWord = 'nameContainsBlockedWord',
  NameMissingPrefixSuffix = 'nameMissingPrefixSuffix',
  BadDomain = 'badDomain',
  AddressAlreadyInUse = 'addressAlreadyInUse',
  NotAllowedByPolicy = 'notAllowedByPolicy'
}

export type ITeamInfo = {
  readonly __typename?: 'TeamInfo',
  readonly profilePicture?: Maybe<IProfilePicture>,
  readonly teamMembersCount?: Maybe<Scalars['Int']>,
};

export type ITeamsCehExtension = {
  readonly __typename?: 'TeamsCehExtension',
  readonly relatedTickets?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly ticketIdToChannelId?: Maybe<IDictionaryOfStringandString>,
};

export type ITicket = {
  readonly __typename?: 'Ticket',
  readonly assignedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly assignedToDisplayName?: Maybe<Scalars['String']>,
  readonly assignedToObjectId?: Maybe<Scalars['String']>,
  readonly attachmentFolderId?: Maybe<Scalars['String']>,
  readonly channelId: Scalars['String'],
  readonly createdBy: Scalars['String'],
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly createdDateTime: Scalars['DateTimeOffset'],
  readonly customerAddress?: Maybe<Scalars['String']>,
  readonly customerDisplayName?: Maybe<Scalars['String']>,
  readonly eTag?: Maybe<Scalars['String']>,
  readonly groupId: Scalars['String'],
  readonly id: Scalars['String'],
  readonly isFollowing?: Maybe<Scalars['Boolean']>,
  readonly itemId: Scalars['String'],
  readonly lastCommunicationAt?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedBy?: Maybe<Scalars['String']>,
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDateTime: Scalars['DateTimeOffset'],
  readonly priority?: Maybe<Priority>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly state: Scalars['String'],
  readonly teamsConversationId?: Maybe<Scalars['String']>,
  readonly title: Scalars['String'],
};

export type ITicketListSelectionState = {
  readonly __typename?: 'TicketListSelectionState',
  readonly selectedTicketIdsList: ReadonlyArray<Maybe<Scalars['String']>>,
};

export type ITicketListSelectionStateInput = {
  readonly selectedTicketIdsList: ReadonlyArray<Maybe<Scalars['String']>>,
};

export type ITicketListState = {
  readonly __typename?: 'TicketListState',
  readonly searchTerm: Scalars['String'],
  readonly sortBy: Scalars['String'],
  readonly filter: IFilterOption,
};

export type ITicketListStateInput = {
  readonly searchTerm: Scalars['String'],
  readonly sortBy: Scalars['String'],
  readonly filter: IFilterOptionInput,
};

export type ITupleOfStringandUri = {
  readonly __typename?: 'TupleOfStringandUri',
  readonly item1?: Maybe<Scalars['String']>,
  readonly item2?: Maybe<IUri>,
};

export type IUpdateEmailAddressInput = {
  readonly address?: Maybe<Scalars['String']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly displayName?: Maybe<Scalars['String']>,
};

export type IUpdateModalityConfigurationInput = {
  readonly groupId: Scalars['String'],
  readonly channelId: Scalars['String'],
  readonly modalityType?: Maybe<Modality>,
  readonly notifyMembers?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly notifyAllMembers?: Maybe<Scalars['Boolean']>,
  readonly proxyAddresses?: Maybe<ReadonlyArray<Maybe<IUpdateEmailAddressInput>>>,
  readonly autoReplyBody?: Maybe<Scalars['String']>,
  readonly state?: Maybe<ModalityState>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly id?: Maybe<Scalars['String']>,
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly eTag?: Maybe<Scalars['String']>,
};

/** ResponseTeamSettings */
export type IUpdateResponseTeamSettingsInput = {
  readonly userObjectId?: Maybe<Scalars['String']>,
  readonly modalityType?: Maybe<Modality>,
  readonly notify?: Maybe<Scalars['Boolean']>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly id?: Maybe<Scalars['String']>,
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly eTag?: Maybe<Scalars['String']>,
};

export type IUpdateTicketInput = {
  readonly groupId?: Maybe<Scalars['String']>,
  readonly channelId?: Maybe<Scalars['String']>,
  readonly teamsConversationId?: Maybe<Scalars['String']>,
  readonly title?: Maybe<Scalars['String']>,
  readonly state?: Maybe<Scalars['String']>,
  readonly priority?: Maybe<Priority>,
  readonly createdBy?: Maybe<Scalars['String']>,
  readonly lastModifiedBy: Scalars['String'],
  readonly assignedToObjectId?: Maybe<Scalars['String']>,
  readonly assignedToDisplayName?: Maybe<Scalars['String']>,
  readonly assignedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly customerDisplayName?: Maybe<Scalars['String']>,
  readonly customerAddress?: Maybe<Scalars['String']>,
  readonly lastCommunicationAt?: Maybe<Scalars['DateTimeOffset']>,
  readonly attachmentFolderId?: Maybe<Scalars['String']>,
  readonly id?: Maybe<Scalars['String']>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly eTag?: Maybe<Scalars['String']>,
};

/** UserNotificationSettings */
export type IUpdateUserNotificationSettingsInput = {
  readonly userObjectId?: Maybe<Scalars['String']>,
  readonly modalityType?: Maybe<Modality>,
  readonly notifyOnTicketChange?: Maybe<Scalars['Boolean']>,
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly id?: Maybe<Scalars['String']>,
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly eTag?: Maybe<Scalars['String']>,
};

export type IUploadResponse = {
  readonly __typename?: 'UploadResponse',
  readonly attachmentSize?: Maybe<Scalars['Int']>,
  readonly downloadUrl?: Maybe<Scalars['String']>,
  readonly end?: Maybe<Scalars['Int']>,
  readonly error?: Maybe<ErrorCode>,
  readonly httpStatus?: Maybe<HttpStatusCode>,
  readonly message?: Maybe<Scalars['String']>,
  readonly start?: Maybe<Scalars['Int']>,
};

export type IUri = {
  readonly __typename?: 'Uri',
  readonly absolutePath?: Maybe<Scalars['String']>,
  readonly absoluteUri?: Maybe<Scalars['String']>,
  readonly authority?: Maybe<Scalars['String']>,
  readonly dnsSafeHost?: Maybe<Scalars['String']>,
  readonly fragment?: Maybe<Scalars['String']>,
  readonly host?: Maybe<Scalars['String']>,
  readonly hostNameType?: Maybe<UriHostNameType>,
  readonly idnHost?: Maybe<Scalars['String']>,
  readonly isAbsoluteUri?: Maybe<Scalars['Boolean']>,
  readonly isDefaultPort?: Maybe<Scalars['Boolean']>,
  readonly isFile?: Maybe<Scalars['Boolean']>,
  readonly isLoopback?: Maybe<Scalars['Boolean']>,
  readonly isUnc?: Maybe<Scalars['Boolean']>,
  readonly localPath?: Maybe<Scalars['String']>,
  readonly originalString?: Maybe<Scalars['String']>,
  readonly pathAndQuery?: Maybe<Scalars['String']>,
  readonly port?: Maybe<Scalars['Int']>,
  readonly query?: Maybe<Scalars['String']>,
  readonly scheme?: Maybe<Scalars['String']>,
  readonly segments?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly userEscaped?: Maybe<Scalars['Boolean']>,
  readonly userInfo?: Maybe<Scalars['String']>,
};

export enum UriHostNameType {
  Unknown = 'unknown',
  Basic = 'basic',
  Dns = 'dns',
  IPv4 = 'iPv4',
  IPv6 = 'iPv6'
}

export type IUser = {
  readonly __typename?: 'User',
  readonly displayName: Scalars['String'],
  readonly givenName?: Maybe<Scalars['String']>,
  readonly id: Scalars['String'],
  readonly mail?: Maybe<Scalars['String']>,
  readonly surname?: Maybe<Scalars['String']>,
  readonly userPrincipalName: Scalars['String'],
};

export type IUserInput = {
  readonly displayName?: Maybe<Scalars['String']>,
  readonly userPrincipalName?: Maybe<Scalars['String']>,
  readonly id?: Maybe<Scalars['String']>,
};

/** UserNotificationSettings */
export type IUserNotificationSettings = {
  readonly __typename?: 'UserNotificationSettings',
  readonly createdDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly createdDateTime: Scalars['DateTimeOffset'],
  readonly eTag?: Maybe<Scalars['String']>,
  readonly id: Scalars['String'],
  readonly itemId: Scalars['String'],
  readonly lastModifiedDate?: Maybe<Scalars['DateTimeOffset']>,
  readonly lastModifiedDateTime: Scalars['DateTimeOffset'],
  readonly modalityType?: Maybe<Modality>,
  readonly notifyOnTicketChange: Scalars['Boolean'],
  readonly secondaryKey?: Maybe<Scalars['String']>,
  readonly userObjectId: Scalars['String'],
};

export type IUserSettings = {
  readonly __typename?: 'UserSettings',
  readonly hideFirstRunExperience: Scalars['Boolean'],
};

export type IUserSettingsInput = {
  readonly hideFirstRunExperience: Scalars['Boolean'],
};

export type IValueCollectionOfStringandString = {
  readonly __typename?: 'ValueCollectionOfStringandString',
  readonly count?: Maybe<Scalars['Int']>,
};

export type IGetTeamInfoQueryVariables = {
  groupId: Scalars['String'],
  displayName: Scalars['String']
};


export type IGetTeamInfoQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getTeamInfo: Maybe<(
    { readonly __typename?: 'TeamInfo' }
    & Pick<ITeamInfo, 'teamMembersCount'>
    & { readonly profilePicture: Maybe<(
      { readonly __typename?: 'ProfilePicture' }
      & Pick<IProfilePicture, 'id' | 'value'>
    )> }
  )> }
);

export type IGetUserProfilePictureQueryVariables = {
  id: Scalars['String'],
  displayName: Scalars['String']
};


export type IGetUserProfilePictureQuery = (
  { readonly __typename?: 'Query' }
  & { readonly userProfilePictureById: Maybe<(
    { readonly __typename?: 'ProfilePicture' }
    & Pick<IProfilePicture, 'id' | 'value'>
  )> }
);

export type IDeleteAllModalitiesMutationVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String']
};


export type IDeleteAllModalitiesMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<IMutation, 'deleteAllModalities'>
);

export type IFollowTicketMutationVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String']
};


export type IFollowTicketMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<IMutation, 'followTicket'>
);

export type IUnfollowTicketMutationVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String']
};


export type IUnfollowTicketMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<IMutation, 'unfollowTicket'>
);

export type IConfigureModalityMutationVariables = {
  newModalityConfiguration: ICreateModalityConfigurationInput
};


export type IConfigureModalityMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly configureModality: Maybe<(
    { readonly __typename?: 'ModalityConfiguration' }
    & Pick<IModalityConfiguration, 'id'>
  )> }
);

export type ICreateResponseTeamSettingsMutationVariables = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  newResponseTeamSettings: ICreateResponseTeamSettingsInput
};


export type ICreateResponseTeamSettingsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createResponseTeamSettings: Maybe<(
    { readonly __typename?: 'ResponseTeamSettings' }
    & Pick<IResponseTeamSettings, 'userObjectId' | 'modalityType' | 'notify'>
  )> }
);

export type ICreateUserNotificationSettingsMutationVariables = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  newUserNotificationSettings: ICreateUserNotificationSettingsInput
};


export type ICreateUserNotificationSettingsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createUserNotificationSettings: Maybe<(
    { readonly __typename?: 'UserNotificationSettings' }
    & IUserNotificationSettingFragmentFragment
  )> }
);

export type IDeleteResponseTeamSettingsMutationVariables = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String']
};


export type IDeleteResponseTeamSettingsMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<IMutation, 'deleteResponseTeamSettings'>
);

export type IDeleteResponseTeamSettingsCollectionMutationVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String']
};


export type IDeleteResponseTeamSettingsCollectionMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<IMutation, 'deleteResponseTeamSettingsCollection'>
);

export type IGetCurrentUsersOwnedGroupsQueryVariables = {};


export type IGetCurrentUsersOwnedGroupsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getCurrentUsersOwnedGroups: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'Group' }
    & Pick<IGroup, 'id' | 'displayName' | 'proxyAddresses'>
  )>>> }
);

export type IGetDomainsQueryVariables = {};


export type IGetDomainsQuery = (
  { readonly __typename?: 'Query' }
  & Pick<IQuery, 'acceptedDomains'>
);

export type IGetGetStartedWizardStateQueryVariables = {};


export type IGetGetStartedWizardStateQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getGetStartedWizardState: Maybe<(
    { readonly __typename?: 'GetStartedWizardState' }
    & Pick<IGetStartedWizardState, 'isActive' | 'draftModalityType' | 'emailSetupMethod' | 'isFinished' | 'step' | 'ringId' | 'configuredEmails' | 'configuredNotifications'>
    & { readonly draftEmailModality: (
      { readonly __typename?: 'EmailModality' }
      & Pick<IEmailModality, 'name' | 'alias' | 'aliasWithoutPrefixAndSuffix' | 'domain' | 'notifyAllUsers' | 'autoReplyText'>
      & { readonly notifyUsers: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'User' }
        & Pick<IUser, 'id' | 'displayName' | 'userPrincipalName'>
      )>>> }
    ) }
  )> }
);

export type ISetGetStartedWizardStateMutationVariables = {
  state: IGetStartedWizardStateInput
};


export type ISetGetStartedWizardStateMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly setGetStartedWizardState: Maybe<(
    { readonly __typename?: 'GetStartedWizardState' }
    & Pick<IGetStartedWizardState, 'isActive' | 'draftModalityType' | 'emailSetupMethod' | 'isFinished' | 'step' | 'ringId' | 'configuredEmails' | 'configuredNotifications'>
    & { readonly draftEmailModality: (
      { readonly __typename?: 'EmailModality' }
      & Pick<IEmailModality, 'name' | 'alias' | 'aliasWithoutPrefixAndSuffix' | 'notifyAllUsers' | 'autoReplyText'>
      & { readonly notifyUsers: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'User' }
        & Pick<IUser, 'id' | 'displayName' | 'userPrincipalName'>
      )>>> }
    ) }
  )> }
);

export type ITestSmtpAvailabilityStatusQueryVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  name: Scalars['String'],
  domain: Scalars['String']
};


export type ITestSmtpAvailabilityStatusQuery = (
  { readonly __typename?: 'Query' }
  & { readonly testSmtpAvailabilityStatus: Maybe<(
    { readonly __typename?: 'SmtpAvailabilityStatus' }
    & Pick<ISmtpAvailabilityStatus, 'state' | 'subState' | 'displayName' | 'prefix' | 'suffix'>
  )> }
);

export type IGetModalityConfigurationQueryVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String']
};


export type IGetModalityConfigurationQuery = (
  { readonly __typename?: 'Query' }
  & { readonly channelModalities: Maybe<(
    { readonly __typename?: 'GraphPageResultOfModalityConfiguration' }
    & { readonly items: ReadonlyArray<Maybe<(
      { readonly __typename?: 'ModalityConfiguration' }
      & IModalityConfigurationFragmentFragment
    )>>, readonly pageInfo: (
      { readonly __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'nextLink' | 'skipToken'>
    ) }
  )> }
);

export type IModalityConfigurationFragmentFragment = (
  { readonly __typename?: 'ModalityConfiguration' }
  & Pick<IModalityConfiguration, 'groupId' | 'channelId' | 'modalityType' | 'notifyMembers' | 'notifyAllMembers' | 'autoReplyBody' | 'state' | 'secondaryKey' | 'id' | 'createdDate' | 'lastModifiedDate' | 'eTag'>
  & { readonly proxyAddresses: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'EmailAddress' }
    & Pick<IEmailAddress, 'address' | 'displayName' | 'name'>
  )>>> }
);

export type IUpdateModalityConfigurationMutationVariables = {
  updateModality: IUpdateModalityConfigurationInput
};


export type IUpdateModalityConfigurationMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateModalityConfiguration: Maybe<(
    { readonly __typename?: 'ModalityConfiguration' }
    & IModalityConfigurationFragmentFragment
  )> }
);

export type IGetResponseTeamSettingsQueryVariables = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  filter?: Maybe<Scalars['String']>,
  sortBy?: Maybe<Scalars['String']>,
  top?: Maybe<Scalars['Int']>,
  skipToken?: Maybe<Scalars['String']>
};


export type IGetResponseTeamSettingsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly responseTeamSettings: Maybe<(
    { readonly __typename?: 'GraphPageResultOfResponseTeamSettings' }
    & { readonly items: ReadonlyArray<Maybe<(
      { readonly __typename?: 'ResponseTeamSettings' }
      & IResponseTeamSettingFragmentFragment
    )>>, readonly pageInfo: (
      { readonly __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'skipToken'>
    ) }
  )> }
);

export type IGetUserNotificationSettingsQueryVariables = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  filter?: Maybe<Scalars['String']>,
  sortBy?: Maybe<Scalars['String']>,
  top?: Maybe<Scalars['Int']>,
  skipToken?: Maybe<Scalars['String']>
};


export type IGetUserNotificationSettingsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly userNotificationSettings: Maybe<(
    { readonly __typename?: 'GraphPageResultOfUserNotificationSettings' }
    & { readonly items: ReadonlyArray<Maybe<(
      { readonly __typename?: 'UserNotificationSettings' }
      & IUserNotificationSettingFragmentFragment
    )>>, readonly pageInfo: (
      { readonly __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'skipToken'>
    ) }
  )> }
);

export type IGetUserProfilePicturesByIdsQueryVariables = {
  ids: ReadonlyArray<Maybe<Scalars['String']>>,
  displayNames: ReadonlyArray<Maybe<Scalars['String']>>
};


export type IGetUserProfilePicturesByIdsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly userProfilePicturesByIds: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'ProfilePicture' }
    & Pick<IProfilePicture, 'id' | 'value'>
  )>>> }
);

export type IGetResponseTeamSettingQueryVariables = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String']
};


export type IGetResponseTeamSettingQuery = (
  { readonly __typename?: 'Query' }
  & { readonly responseTeamSetting: Maybe<(
    { readonly __typename?: 'ResponseTeamSettings' }
    & IResponseTeamSettingFragmentFragment
  )> }
);

export type IGetUserNotificationSettingQueryVariables = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String']
};


export type IGetUserNotificationSettingQuery = (
  { readonly __typename?: 'Query' }
  & { readonly userNotificationSetting: Maybe<(
    { readonly __typename?: 'UserNotificationSettings' }
    & IUserNotificationSettingFragmentFragment
  )> }
);

export type IGetUsersByIdsQueryVariables = {
  userIds: ReadonlyArray<Maybe<Scalars['String']>>
};


export type IGetUsersByIdsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getUsersByIds: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'User' }
    & Pick<IUser, 'displayName' | 'id' | 'userPrincipalName'>
  )>>> }
);

export type IResponseTeamSettingFragmentFragment = (
  { readonly __typename?: 'ResponseTeamSettings' }
  & Pick<IResponseTeamSettings, 'createdDate' | 'createdDateTime' | 'eTag' | 'id' | 'itemId' | 'lastModifiedDate' | 'lastModifiedDateTime' | 'modalityType' | 'notify' | 'userObjectId'>
);

export type IUpdateResponseTeamSettingsMutationVariables = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String'],
  updatedResponseTeamSettings: IUpdateResponseTeamSettingsInput
};


export type IUpdateResponseTeamSettingsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateResponseTeamSettings: Maybe<(
    { readonly __typename?: 'ResponseTeamSettings' }
    & IResponseTeamSettingFragmentFragment
  )> }
);

export type IUpdateUserNotificationSettingsMutationVariables = {
  groupId: Scalars['String'],
  modalityId: Scalars['String'],
  userObjectId: Scalars['String'],
  updatedUserNotificationSettings: IUpdateUserNotificationSettingsInput
};


export type IUpdateUserNotificationSettingsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateUserNotificationSetting: Maybe<(
    { readonly __typename?: 'UserNotificationSettings' }
    & IUserNotificationSettingFragmentFragment
  )> }
);

export type IUserNotificationSettingFragmentFragment = (
  { readonly __typename?: 'UserNotificationSettings' }
  & Pick<IUserNotificationSettings, 'id' | 'userObjectId' | 'notifyOnTicketChange' | 'createdDateTime' | 'lastModifiedDateTime' | 'itemId'>
);

export type ISearchTeamMembersQueryVariables = {
  teamId: Scalars['String'],
  top: Scalars['Int'],
  search: Scalars['String']
};


export type ISearchTeamMembersQuery = (
  { readonly __typename?: 'Query' }
  & { readonly searchTeamMembers: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'User' }
    & Pick<IUser, 'userPrincipalName' | 'displayName' | 'id'>
  )>>> }
);

export type IEnsureRecipientPermissionIsSetQueryVariables = {
  modernGroupSmtp: Scalars['String'],
  userSmtp: Scalars['String']
};


export type IEnsureRecipientPermissionIsSetQuery = (
  { readonly __typename?: 'Query' }
  & Pick<IQuery, 'ensureRecipientPermissionIsSet'>
);

export type IGetChannelModalitiesQueryVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String']
};


export type IGetChannelModalitiesQuery = (
  { readonly __typename?: 'Query' }
  & { readonly channelModalities: Maybe<(
    { readonly __typename?: 'GraphPageResultOfModalityConfiguration' }
    & { readonly items: ReadonlyArray<Maybe<(
      { readonly __typename?: 'ModalityConfiguration' }
      & IModalityConfigurationFragmentFragment
    )>> }
  )> }
);

export type IGetSendAsStateQueryVariables = {};


export type IGetSendAsStateQuery = (
  { readonly __typename?: 'Query' }
  & { readonly sendAsState: Maybe<(
    { readonly __typename?: 'SendAsState' }
    & Pick<ISendAsState, 'timeSet'>
  )> }
);

export type ISetSendAsStateMutationVariables = {
  sendAsState: ISendAsStateInput
};


export type ISetSendAsStateMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly setSendAsState: Maybe<(
    { readonly __typename?: 'SendAsState' }
    & Pick<ISendAsState, 'timeSet'>
  )> }
);

export type ICreateTicketMutationVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  newTicket: ICreateTicketInput
};


export type ICreateTicketMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createTicket: Maybe<(
    { readonly __typename?: 'Ticket' }
    & Pick<ITicket, 'id' | 'title' | 'customerDisplayName' | 'customerAddress' | 'assignedToObjectId' | 'assignedToDisplayName' | 'state' | 'lastModifiedDateTime' | 'createdDateTime'>
  )> }
);

export type IGetEmailsByTicketIdQueryVariables = {
  groupId: Scalars['String'],
  ticketId: Scalars['String'],
  top?: Maybe<Scalars['Int']>
};


export type IGetEmailsByTicketIdQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getEmailsByTicketId: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'EmailMessage' }
    & Pick<IEmailMessage, 'id' | 'conversationId' | 'internetMessageId' | 'hasAttachments' | 'receivedDateTime' | 'subject' | 'bodyPreview'>
    & { readonly from: Maybe<(
      { readonly __typename?: 'Recipient' }
      & { readonly emailAddress: Maybe<(
        { readonly __typename?: 'EmailAddress' }
        & Pick<IEmailAddress, 'address' | 'name'>
      )> }
    )>, readonly toRecipients: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Recipient' }
      & { readonly emailAddress: Maybe<(
        { readonly __typename?: 'EmailAddress' }
        & Pick<IEmailAddress, 'address' | 'name'>
      )> }
    )>>>, readonly body: Maybe<(
      { readonly __typename?: 'MessageBody' }
      & Pick<IMessageBody, 'content' | 'contentType'>
    )> }
  )>>> }
);

export type IGetGroupQueryVariables = {
  groupId: Scalars['String']
};


export type IGetGroupQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getGroup: Maybe<(
    { readonly __typename?: 'ExchangeGroup' }
    & Pick<IExchangeGroup, 'id' | 'emailAddress'>
  )> }
);

export type IRespondToEmailMutationVariables = {
  itemId: Scalars['String'],
  groupId: Scalars['String'],
  action: EmailResponseActions
};


export type IRespondToEmailMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<IMutation, 'respondToEmail'>
);

export type IUpdateTicketMutationVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String'],
  updatedTicket: IUpdateTicketInput
};


export type IUpdateTicketMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateTicket: Maybe<(
    { readonly __typename?: 'Ticket' }
    & Pick<ITicket, 'id' | 'title' | 'customerDisplayName' | 'customerAddress' | 'assignedToObjectId' | 'assignedToDisplayName' | 'state' | 'lastModifiedDateTime' | 'createdDateTime' | 'teamsConversationId'>
  )> }
);

export type IGetTicketActivitiesQueryVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String'],
  filter?: Maybe<Scalars['String']>,
  sortBy?: Maybe<Scalars['String']>,
  top?: Maybe<Scalars['Int']>,
  skipToken?: Maybe<Scalars['String']>
};


export type IGetTicketActivitiesQuery = (
  { readonly __typename?: 'Query' }
  & { readonly ticketActivities: Maybe<(
    { readonly __typename?: 'GraphPageResultOfActivity' }
    & { readonly items: ReadonlyArray<Maybe<(
      { readonly __typename?: 'Activity' }
      & Pick<IActivity, 'actionType' | 'actorId' | 'actorName' | 'actionTime' | 'createdDateTime' | 'eTag' | 'id' | 'lastModifiedDateTime' | 'ticketId' | 'type'>
      & { readonly delta: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'ChangeDetail' }
        & Pick<IChangeDetail, 'currentValue' | 'previousValue' | 'propertyPath'>
      )>>> }
    )>>, readonly pageInfo: (
      { readonly __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'nextLink' | 'skipToken'>
    ) }
  )> }
);

export type ISetTicketListSelectionStateMutationVariables = {
  state: ITicketListSelectionStateInput
};


export type ISetTicketListSelectionStateMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly setTicketListSelectionState: Maybe<(
    { readonly __typename?: 'TicketListSelectionState' }
    & Pick<ITicketListSelectionState, 'selectedTicketIdsList'>
  )> }
);

export type ISetTicketListStateMutationVariables = {
  state: ITicketListStateInput
};


export type ISetTicketListStateMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly setTicketListState: Maybe<(
    { readonly __typename?: 'TicketListState' }
    & ITicketListStateFragmentFragment
  )> }
);

export type IGetTicketQueryVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketId: Scalars['String']
};


export type IGetTicketQuery = (
  { readonly __typename?: 'Query' }
  & { readonly ticket: Maybe<(
    { readonly __typename?: 'Ticket' }
    & Pick<ITicket, 'id' | 'itemId' | 'groupId' | 'channelId' | 'title' | 'createdDateTime' | 'customerDisplayName' | 'customerAddress' | 'assignedToObjectId' | 'assignedToDisplayName' | 'state' | 'lastModifiedDateTime' | 'lastCommunicationAt' | 'createdBy' | 'teamsConversationId' | 'isFollowing'>
  )> }
);

export type IGetTicketListQueryVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  filter?: Maybe<Scalars['String']>,
  sortBy?: Maybe<Scalars['String']>,
  top: Scalars['Int'],
  skipToken?: Maybe<Scalars['String']>
};


export type IGetTicketListQuery = (
  { readonly __typename?: 'Query' }
  & { readonly tickets: Maybe<(
    { readonly __typename?: 'GraphPageResultOfTicket' }
    & { readonly items: ReadonlyArray<Maybe<(
      { readonly __typename?: 'Ticket' }
      & Pick<ITicket, 'id' | 'itemId' | 'groupId' | 'channelId' | 'title' | 'createdDateTime' | 'customerDisplayName' | 'customerAddress' | 'assignedToObjectId' | 'assignedToDisplayName' | 'state' | 'lastModifiedDateTime' | 'lastCommunicationAt' | 'createdBy' | 'teamsConversationId' | 'isFollowing'>
    )>>, readonly pageInfo: (
      { readonly __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'nextLink' | 'skipToken'>
    ) }
  )> }
);

export type IGetTicketListSelectionStateQueryVariables = {};


export type IGetTicketListSelectionStateQuery = (
  { readonly __typename?: 'Query' }
  & { readonly ticketListSelectionState: Maybe<(
    { readonly __typename?: 'TicketListSelectionState' }
    & Pick<ITicketListSelectionState, 'selectedTicketIdsList'>
  )> }
);

export type IGetTicketListStateQueryVariables = {};


export type IGetTicketListStateQuery = (
  { readonly __typename?: 'Query' }
  & { readonly ticketListState: Maybe<(
    { readonly __typename?: 'TicketListState' }
    & ITicketListStateFragmentFragment
  )> }
);

export type IGetTicketListWatermarkQueryVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  lastKnownDateTime?: Maybe<Scalars['String']>
};


export type IGetTicketListWatermarkQuery = (
  { readonly __typename?: 'Query' }
  & Pick<IQuery, 'ticketsWatermark'>
);

export type IGetUserProfilePicturesQueryVariables = {
  ids: ReadonlyArray<Maybe<Scalars['String']>>,
  displayNames: ReadonlyArray<Maybe<Scalars['String']>>
};


export type IGetUserProfilePicturesQuery = (
  { readonly __typename?: 'Query' }
  & { readonly userProfilePicturesByIds: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'ProfilePicture' }
    & Pick<IProfilePicture, 'id' | 'value'>
  )>>> }
);

export type IGetUserSettingsQueryVariables = {};


export type IGetUserSettingsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly userSettings: Maybe<(
    { readonly __typename?: 'UserSettings' }
    & Pick<IUserSettings, 'hideFirstRunExperience'>
  )> }
);

export type ITicketListStateFragmentFragment = (
  { readonly __typename?: 'TicketListState' }
  & Pick<ITicketListState, 'searchTerm' | 'sortBy'>
  & { readonly filter: (
    { readonly __typename?: 'FilterOption' }
    & Pick<IFilterOption, 'stateFilterOption' | 'ageFilterOption' | 'assignmentFilterOption' | 'followFilterOption'>
  ) }
);

export type IUpdateTicketsMutationVariables = {
  groupId: Scalars['String'],
  channelId: Scalars['String'],
  ticketIds: ReadonlyArray<Maybe<Scalars['String']>>,
  updatedTickets: ReadonlyArray<Maybe<IUpdateTicketInput>>
};


export type IUpdateTicketsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateTickets: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'Ticket' }
    & Pick<ITicket, 'id' | 'title' | 'customerDisplayName' | 'customerAddress' | 'assignedToObjectId' | 'assignedToDisplayName' | 'state' | 'lastModifiedDateTime' | 'createdDateTime' | 'teamsConversationId'>
  )>>> }
);

export type IUpdateUserSettingsMutationVariables = {
  userSettings: IUserSettingsInput
};


export type IUpdateUserSettingsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly setUserSettings: Maybe<(
    { readonly __typename?: 'UserSettings' }
    & Pick<IUserSettings, 'hideFirstRunExperience'>
  )> }
);

export type IGetAriaKeyQueryVariables = {
  clientType: AriaKeyClientType
};


export type IGetAriaKeyQuery = (
  { readonly __typename?: 'Query' }
  & Pick<IQuery, 'getAriaKey'>
);

export const ModalityConfigurationFragmentFragmentDoc = gql`
    fragment ModalityConfigurationFragment on ModalityConfiguration {
  groupId
  channelId
  modalityType
  notifyMembers
  notifyAllMembers
  proxyAddresses {
    address
    displayName
    name
  }
  autoReplyBody
  state
  secondaryKey
  id
  createdDate
  lastModifiedDate
  eTag
}
    `;
export const ResponseTeamSettingFragmentFragmentDoc = gql`
    fragment ResponseTeamSettingFragment on ResponseTeamSettings {
  createdDate
  createdDateTime
  eTag
  id
  itemId
  lastModifiedDate
  lastModifiedDateTime
  modalityType
  notify
  userObjectId
}
    `;
export const UserNotificationSettingFragmentFragmentDoc = gql`
    fragment UserNotificationSettingFragment on UserNotificationSettings {
  id
  userObjectId
  notifyOnTicketChange
  createdDateTime
  lastModifiedDateTime
  itemId
}
    `;
export const TicketListStateFragmentFragmentDoc = gql`
    fragment TicketListStateFragment on TicketListState {
  searchTerm
  sortBy
  filter {
    stateFilterOption
    ageFilterOption
    assignmentFilterOption
    followFilterOption
  }
}
    `;
export const GetTeamInfoDocument = gql`
    query GetTeamInfo($groupId: String!, $displayName: String!) {
  getTeamInfo(groupId: $groupId, displayName: $displayName) {
    teamMembersCount
    profilePicture {
      id
      value
    }
  }
}
    `;

/**
 * __useGetTeamInfoQuery__
 *
 * To run a query within a React component, call `useGetTeamInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useGetTeamInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetTeamInfoQuery, IGetTeamInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetTeamInfoQuery, IGetTeamInfoQueryVariables>(GetTeamInfoDocument, baseOptions);
      }
export function useGetTeamInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetTeamInfoQuery, IGetTeamInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetTeamInfoQuery, IGetTeamInfoQueryVariables>(GetTeamInfoDocument, baseOptions);
        }
export type GetTeamInfoQueryHookResult = ReturnType<typeof useGetTeamInfoQuery>;
export type GetTeamInfoLazyQueryHookResult = ReturnType<typeof useGetTeamInfoLazyQuery>;
export type GetTeamInfoQueryResult = ApolloReactCommon.QueryResult<IGetTeamInfoQuery, IGetTeamInfoQueryVariables>;
export const GetUserProfilePictureDocument = gql`
    query GetUserProfilePicture($id: String!, $displayName: String!) {
  userProfilePictureById(id: $id, displayName: $displayName) {
    id
    value
  }
}
    `;

/**
 * __useGetUserProfilePictureQuery__
 *
 * To run a query within a React component, call `useGetUserProfilePictureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfilePictureQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfilePictureQuery({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useGetUserProfilePictureQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserProfilePictureQuery, IGetUserProfilePictureQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserProfilePictureQuery, IGetUserProfilePictureQueryVariables>(GetUserProfilePictureDocument, baseOptions);
      }
export function useGetUserProfilePictureLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserProfilePictureQuery, IGetUserProfilePictureQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserProfilePictureQuery, IGetUserProfilePictureQueryVariables>(GetUserProfilePictureDocument, baseOptions);
        }
export type GetUserProfilePictureQueryHookResult = ReturnType<typeof useGetUserProfilePictureQuery>;
export type GetUserProfilePictureLazyQueryHookResult = ReturnType<typeof useGetUserProfilePictureLazyQuery>;
export type GetUserProfilePictureQueryResult = ApolloReactCommon.QueryResult<IGetUserProfilePictureQuery, IGetUserProfilePictureQueryVariables>;
export const DeleteAllModalitiesDocument = gql`
    mutation DeleteAllModalities($groupId: String!, $channelId: String!) {
  deleteAllModalities(groupId: $groupId, channelId: $channelId)
}
    `;
export type IDeleteAllModalitiesMutationFn = ApolloReactCommon.MutationFunction<IDeleteAllModalitiesMutation, IDeleteAllModalitiesMutationVariables>;

/**
 * __useDeleteAllModalitiesMutation__
 *
 * To run a mutation, you first call `useDeleteAllModalitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllModalitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllModalitiesMutation, { data, loading, error }] = useDeleteAllModalitiesMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDeleteAllModalitiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IDeleteAllModalitiesMutation, IDeleteAllModalitiesMutationVariables>) {
        return ApolloReactHooks.useMutation<IDeleteAllModalitiesMutation, IDeleteAllModalitiesMutationVariables>(DeleteAllModalitiesDocument, baseOptions);
      }
export type DeleteAllModalitiesMutationHookResult = ReturnType<typeof useDeleteAllModalitiesMutation>;
export type DeleteAllModalitiesMutationResult = ApolloReactCommon.MutationResult<IDeleteAllModalitiesMutation>;
export type DeleteAllModalitiesMutationOptions = ApolloReactCommon.BaseMutationOptions<IDeleteAllModalitiesMutation, IDeleteAllModalitiesMutationVariables>;
export const FollowTicketDocument = gql`
    mutation FollowTicket($groupId: String!, $channelId: String!, $ticketId: String!) {
  followTicket(groupId: $groupId, channelId: $channelId, ticketId: $ticketId)
}
    `;
export type IFollowTicketMutationFn = ApolloReactCommon.MutationFunction<IFollowTicketMutation, IFollowTicketMutationVariables>;

/**
 * __useFollowTicketMutation__
 *
 * To run a mutation, you first call `useFollowTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followTicketMutation, { data, loading, error }] = useFollowTicketMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useFollowTicketMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IFollowTicketMutation, IFollowTicketMutationVariables>) {
        return ApolloReactHooks.useMutation<IFollowTicketMutation, IFollowTicketMutationVariables>(FollowTicketDocument, baseOptions);
      }
export type FollowTicketMutationHookResult = ReturnType<typeof useFollowTicketMutation>;
export type FollowTicketMutationResult = ApolloReactCommon.MutationResult<IFollowTicketMutation>;
export type FollowTicketMutationOptions = ApolloReactCommon.BaseMutationOptions<IFollowTicketMutation, IFollowTicketMutationVariables>;
export const UnfollowTicketDocument = gql`
    mutation UnfollowTicket($groupId: String!, $channelId: String!, $ticketId: String!) {
  unfollowTicket(groupId: $groupId, channelId: $channelId, ticketId: $ticketId)
}
    `;
export type IUnfollowTicketMutationFn = ApolloReactCommon.MutationFunction<IUnfollowTicketMutation, IUnfollowTicketMutationVariables>;

/**
 * __useUnfollowTicketMutation__
 *
 * To run a mutation, you first call `useUnfollowTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowTicketMutation, { data, loading, error }] = useUnfollowTicketMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useUnfollowTicketMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUnfollowTicketMutation, IUnfollowTicketMutationVariables>) {
        return ApolloReactHooks.useMutation<IUnfollowTicketMutation, IUnfollowTicketMutationVariables>(UnfollowTicketDocument, baseOptions);
      }
export type UnfollowTicketMutationHookResult = ReturnType<typeof useUnfollowTicketMutation>;
export type UnfollowTicketMutationResult = ApolloReactCommon.MutationResult<IUnfollowTicketMutation>;
export type UnfollowTicketMutationOptions = ApolloReactCommon.BaseMutationOptions<IUnfollowTicketMutation, IUnfollowTicketMutationVariables>;
export const ConfigureModalityDocument = gql`
    mutation ConfigureModality($newModalityConfiguration: CreateModalityConfigurationInput!) {
  configureModality(config: $newModalityConfiguration) {
    id
  }
}
    `;
export type IConfigureModalityMutationFn = ApolloReactCommon.MutationFunction<IConfigureModalityMutation, IConfigureModalityMutationVariables>;

/**
 * __useConfigureModalityMutation__
 *
 * To run a mutation, you first call `useConfigureModalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureModalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureModalityMutation, { data, loading, error }] = useConfigureModalityMutation({
 *   variables: {
 *      newModalityConfiguration: // value for 'newModalityConfiguration'
 *   },
 * });
 */
export function useConfigureModalityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IConfigureModalityMutation, IConfigureModalityMutationVariables>) {
        return ApolloReactHooks.useMutation<IConfigureModalityMutation, IConfigureModalityMutationVariables>(ConfigureModalityDocument, baseOptions);
      }
export type ConfigureModalityMutationHookResult = ReturnType<typeof useConfigureModalityMutation>;
export type ConfigureModalityMutationResult = ApolloReactCommon.MutationResult<IConfigureModalityMutation>;
export type ConfigureModalityMutationOptions = ApolloReactCommon.BaseMutationOptions<IConfigureModalityMutation, IConfigureModalityMutationVariables>;
export const CreateResponseTeamSettingsDocument = gql`
    mutation CreateResponseTeamSettings($groupId: String!, $modalityId: String!, $newResponseTeamSettings: CreateResponseTeamSettingsInput!) {
  createResponseTeamSettings(groupId: $groupId, modalityId: $modalityId, newResponseTeamSettings: $newResponseTeamSettings) {
    userObjectId
    modalityType
    notify
  }
}
    `;
export type ICreateResponseTeamSettingsMutationFn = ApolloReactCommon.MutationFunction<ICreateResponseTeamSettingsMutation, ICreateResponseTeamSettingsMutationVariables>;

/**
 * __useCreateResponseTeamSettingsMutation__
 *
 * To run a mutation, you first call `useCreateResponseTeamSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResponseTeamSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResponseTeamSettingsMutation, { data, loading, error }] = useCreateResponseTeamSettingsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      modalityId: // value for 'modalityId'
 *      newResponseTeamSettings: // value for 'newResponseTeamSettings'
 *   },
 * });
 */
export function useCreateResponseTeamSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateResponseTeamSettingsMutation, ICreateResponseTeamSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateResponseTeamSettingsMutation, ICreateResponseTeamSettingsMutationVariables>(CreateResponseTeamSettingsDocument, baseOptions);
      }
export type CreateResponseTeamSettingsMutationHookResult = ReturnType<typeof useCreateResponseTeamSettingsMutation>;
export type CreateResponseTeamSettingsMutationResult = ApolloReactCommon.MutationResult<ICreateResponseTeamSettingsMutation>;
export type CreateResponseTeamSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateResponseTeamSettingsMutation, ICreateResponseTeamSettingsMutationVariables>;
export const CreateUserNotificationSettingsDocument = gql`
    mutation CreateUserNotificationSettings($groupId: String!, $modalityId: String!, $newUserNotificationSettings: CreateUserNotificationSettingsInput!) {
  createUserNotificationSettings(groupId: $groupId, modalityId: $modalityId, newUserNotificationSettings: $newUserNotificationSettings) {
    ...UserNotificationSettingFragment
  }
}
    ${UserNotificationSettingFragmentFragmentDoc}`;
export type ICreateUserNotificationSettingsMutationFn = ApolloReactCommon.MutationFunction<ICreateUserNotificationSettingsMutation, ICreateUserNotificationSettingsMutationVariables>;

/**
 * __useCreateUserNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useCreateUserNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserNotificationSettingsMutation, { data, loading, error }] = useCreateUserNotificationSettingsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      modalityId: // value for 'modalityId'
 *      newUserNotificationSettings: // value for 'newUserNotificationSettings'
 *   },
 * });
 */
export function useCreateUserNotificationSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateUserNotificationSettingsMutation, ICreateUserNotificationSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateUserNotificationSettingsMutation, ICreateUserNotificationSettingsMutationVariables>(CreateUserNotificationSettingsDocument, baseOptions);
      }
export type CreateUserNotificationSettingsMutationHookResult = ReturnType<typeof useCreateUserNotificationSettingsMutation>;
export type CreateUserNotificationSettingsMutationResult = ApolloReactCommon.MutationResult<ICreateUserNotificationSettingsMutation>;
export type CreateUserNotificationSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateUserNotificationSettingsMutation, ICreateUserNotificationSettingsMutationVariables>;
export const DeleteResponseTeamSettingsDocument = gql`
    mutation DeleteResponseTeamSettings($groupId: String!, $modalityId: String!, $userObjectId: String!) {
  deleteResponseTeamSettings(groupId: $groupId, modalityId: $modalityId, userObjectId: $userObjectId)
}
    `;
export type IDeleteResponseTeamSettingsMutationFn = ApolloReactCommon.MutationFunction<IDeleteResponseTeamSettingsMutation, IDeleteResponseTeamSettingsMutationVariables>;

/**
 * __useDeleteResponseTeamSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteResponseTeamSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResponseTeamSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResponseTeamSettingsMutation, { data, loading, error }] = useDeleteResponseTeamSettingsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      modalityId: // value for 'modalityId'
 *      userObjectId: // value for 'userObjectId'
 *   },
 * });
 */
export function useDeleteResponseTeamSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IDeleteResponseTeamSettingsMutation, IDeleteResponseTeamSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<IDeleteResponseTeamSettingsMutation, IDeleteResponseTeamSettingsMutationVariables>(DeleteResponseTeamSettingsDocument, baseOptions);
      }
export type DeleteResponseTeamSettingsMutationHookResult = ReturnType<typeof useDeleteResponseTeamSettingsMutation>;
export type DeleteResponseTeamSettingsMutationResult = ApolloReactCommon.MutationResult<IDeleteResponseTeamSettingsMutation>;
export type DeleteResponseTeamSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<IDeleteResponseTeamSettingsMutation, IDeleteResponseTeamSettingsMutationVariables>;
export const DeleteResponseTeamSettingsCollectionDocument = gql`
    mutation DeleteResponseTeamSettingsCollection($groupId: String!, $channelId: String!) {
  deleteResponseTeamSettingsCollection(groupId: $groupId, channelId: $channelId)
}
    `;
export type IDeleteResponseTeamSettingsCollectionMutationFn = ApolloReactCommon.MutationFunction<IDeleteResponseTeamSettingsCollectionMutation, IDeleteResponseTeamSettingsCollectionMutationVariables>;

/**
 * __useDeleteResponseTeamSettingsCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteResponseTeamSettingsCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResponseTeamSettingsCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResponseTeamSettingsCollectionMutation, { data, loading, error }] = useDeleteResponseTeamSettingsCollectionMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDeleteResponseTeamSettingsCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IDeleteResponseTeamSettingsCollectionMutation, IDeleteResponseTeamSettingsCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<IDeleteResponseTeamSettingsCollectionMutation, IDeleteResponseTeamSettingsCollectionMutationVariables>(DeleteResponseTeamSettingsCollectionDocument, baseOptions);
      }
export type DeleteResponseTeamSettingsCollectionMutationHookResult = ReturnType<typeof useDeleteResponseTeamSettingsCollectionMutation>;
export type DeleteResponseTeamSettingsCollectionMutationResult = ApolloReactCommon.MutationResult<IDeleteResponseTeamSettingsCollectionMutation>;
export type DeleteResponseTeamSettingsCollectionMutationOptions = ApolloReactCommon.BaseMutationOptions<IDeleteResponseTeamSettingsCollectionMutation, IDeleteResponseTeamSettingsCollectionMutationVariables>;
export const GetCurrentUsersOwnedGroupsDocument = gql`
    query GetCurrentUsersOwnedGroups {
  getCurrentUsersOwnedGroups {
    id
    displayName
    proxyAddresses
  }
}
    `;

/**
 * __useGetCurrentUsersOwnedGroupsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUsersOwnedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUsersOwnedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUsersOwnedGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUsersOwnedGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetCurrentUsersOwnedGroupsQuery, IGetCurrentUsersOwnedGroupsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetCurrentUsersOwnedGroupsQuery, IGetCurrentUsersOwnedGroupsQueryVariables>(GetCurrentUsersOwnedGroupsDocument, baseOptions);
      }
export function useGetCurrentUsersOwnedGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetCurrentUsersOwnedGroupsQuery, IGetCurrentUsersOwnedGroupsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetCurrentUsersOwnedGroupsQuery, IGetCurrentUsersOwnedGroupsQueryVariables>(GetCurrentUsersOwnedGroupsDocument, baseOptions);
        }
export type GetCurrentUsersOwnedGroupsQueryHookResult = ReturnType<typeof useGetCurrentUsersOwnedGroupsQuery>;
export type GetCurrentUsersOwnedGroupsLazyQueryHookResult = ReturnType<typeof useGetCurrentUsersOwnedGroupsLazyQuery>;
export type GetCurrentUsersOwnedGroupsQueryResult = ApolloReactCommon.QueryResult<IGetCurrentUsersOwnedGroupsQuery, IGetCurrentUsersOwnedGroupsQueryVariables>;
export const GetDomainsDocument = gql`
    query GetDomains {
  acceptedDomains
}
    `;

/**
 * __useGetDomainsQuery__
 *
 * To run a query within a React component, call `useGetDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDomainsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetDomainsQuery, IGetDomainsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetDomainsQuery, IGetDomainsQueryVariables>(GetDomainsDocument, baseOptions);
      }
export function useGetDomainsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetDomainsQuery, IGetDomainsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetDomainsQuery, IGetDomainsQueryVariables>(GetDomainsDocument, baseOptions);
        }
export type GetDomainsQueryHookResult = ReturnType<typeof useGetDomainsQuery>;
export type GetDomainsLazyQueryHookResult = ReturnType<typeof useGetDomainsLazyQuery>;
export type GetDomainsQueryResult = ApolloReactCommon.QueryResult<IGetDomainsQuery, IGetDomainsQueryVariables>;
export const GetGetStartedWizardStateDocument = gql`
    query GetGetStartedWizardState {
  getGetStartedWizardState @client {
    isActive
    draftEmailModality {
      name
      alias
      aliasWithoutPrefixAndSuffix
      domain
      notifyUsers {
        id
        displayName
        userPrincipalName
      }
      notifyAllUsers
      autoReplyText
    }
    draftModalityType
    emailSetupMethod
    isFinished
    step
    ringId
    configuredEmails
    configuredNotifications
  }
}
    `;

/**
 * __useGetGetStartedWizardStateQuery__
 *
 * To run a query within a React component, call `useGetGetStartedWizardStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGetStartedWizardStateQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGetStartedWizardStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGetStartedWizardStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetGetStartedWizardStateQuery, IGetGetStartedWizardStateQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetGetStartedWizardStateQuery, IGetGetStartedWizardStateQueryVariables>(GetGetStartedWizardStateDocument, baseOptions);
      }
export function useGetGetStartedWizardStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetGetStartedWizardStateQuery, IGetGetStartedWizardStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetGetStartedWizardStateQuery, IGetGetStartedWizardStateQueryVariables>(GetGetStartedWizardStateDocument, baseOptions);
        }
export type GetGetStartedWizardStateQueryHookResult = ReturnType<typeof useGetGetStartedWizardStateQuery>;
export type GetGetStartedWizardStateLazyQueryHookResult = ReturnType<typeof useGetGetStartedWizardStateLazyQuery>;
export type GetGetStartedWizardStateQueryResult = ApolloReactCommon.QueryResult<IGetGetStartedWizardStateQuery, IGetGetStartedWizardStateQueryVariables>;
export const SetGetStartedWizardStateDocument = gql`
    mutation SetGetStartedWizardState($state: GetStartedWizardStateInput!) {
  setGetStartedWizardState(wizardState: $state) @client {
    isActive
    draftEmailModality {
      name
      alias
      aliasWithoutPrefixAndSuffix
      notifyUsers {
        id
        displayName
        userPrincipalName
      }
      notifyAllUsers
      autoReplyText
    }
    draftModalityType
    emailSetupMethod
    isFinished
    step
    ringId
    configuredEmails
    configuredNotifications
  }
}
    `;
export type ISetGetStartedWizardStateMutationFn = ApolloReactCommon.MutationFunction<ISetGetStartedWizardStateMutation, ISetGetStartedWizardStateMutationVariables>;

/**
 * __useSetGetStartedWizardStateMutation__
 *
 * To run a mutation, you first call `useSetGetStartedWizardStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGetStartedWizardStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGetStartedWizardStateMutation, { data, loading, error }] = useSetGetStartedWizardStateMutation({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSetGetStartedWizardStateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISetGetStartedWizardStateMutation, ISetGetStartedWizardStateMutationVariables>) {
        return ApolloReactHooks.useMutation<ISetGetStartedWizardStateMutation, ISetGetStartedWizardStateMutationVariables>(SetGetStartedWizardStateDocument, baseOptions);
      }
export type SetGetStartedWizardStateMutationHookResult = ReturnType<typeof useSetGetStartedWizardStateMutation>;
export type SetGetStartedWizardStateMutationResult = ApolloReactCommon.MutationResult<ISetGetStartedWizardStateMutation>;
export type SetGetStartedWizardStateMutationOptions = ApolloReactCommon.BaseMutationOptions<ISetGetStartedWizardStateMutation, ISetGetStartedWizardStateMutationVariables>;
export const TestSmtpAvailabilityStatusDocument = gql`
    query TestSmtpAvailabilityStatus($groupId: String!, $channelId: String!, $name: String!, $domain: String!) {
  testSmtpAvailabilityStatus(groupId: $groupId, channelId: $channelId, name: $name, domain: $domain) {
    state
    subState
    displayName
    prefix
    suffix
  }
}
    `;

/**
 * __useTestSmtpAvailabilityStatusQuery__
 *
 * To run a query within a React component, call `useTestSmtpAvailabilityStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestSmtpAvailabilityStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestSmtpAvailabilityStatusQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      name: // value for 'name'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useTestSmtpAvailabilityStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ITestSmtpAvailabilityStatusQuery, ITestSmtpAvailabilityStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<ITestSmtpAvailabilityStatusQuery, ITestSmtpAvailabilityStatusQueryVariables>(TestSmtpAvailabilityStatusDocument, baseOptions);
      }
export function useTestSmtpAvailabilityStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ITestSmtpAvailabilityStatusQuery, ITestSmtpAvailabilityStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ITestSmtpAvailabilityStatusQuery, ITestSmtpAvailabilityStatusQueryVariables>(TestSmtpAvailabilityStatusDocument, baseOptions);
        }
export type TestSmtpAvailabilityStatusQueryHookResult = ReturnType<typeof useTestSmtpAvailabilityStatusQuery>;
export type TestSmtpAvailabilityStatusLazyQueryHookResult = ReturnType<typeof useTestSmtpAvailabilityStatusLazyQuery>;
export type TestSmtpAvailabilityStatusQueryResult = ApolloReactCommon.QueryResult<ITestSmtpAvailabilityStatusQuery, ITestSmtpAvailabilityStatusQueryVariables>;
export const GetModalityConfigurationDocument = gql`
    query GetModalityConfiguration($groupId: String!, $channelId: String!) {
  channelModalities(groupId: $groupId, channelId: $channelId) {
    items {
      ...ModalityConfigurationFragment
    }
    pageInfo {
      nextLink
      skipToken
    }
  }
}
    ${ModalityConfigurationFragmentFragmentDoc}`;

/**
 * __useGetModalityConfigurationQuery__
 *
 * To run a query within a React component, call `useGetModalityConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModalityConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModalityConfigurationQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetModalityConfigurationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetModalityConfigurationQuery, IGetModalityConfigurationQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetModalityConfigurationQuery, IGetModalityConfigurationQueryVariables>(GetModalityConfigurationDocument, baseOptions);
      }
export function useGetModalityConfigurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetModalityConfigurationQuery, IGetModalityConfigurationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetModalityConfigurationQuery, IGetModalityConfigurationQueryVariables>(GetModalityConfigurationDocument, baseOptions);
        }
export type GetModalityConfigurationQueryHookResult = ReturnType<typeof useGetModalityConfigurationQuery>;
export type GetModalityConfigurationLazyQueryHookResult = ReturnType<typeof useGetModalityConfigurationLazyQuery>;
export type GetModalityConfigurationQueryResult = ApolloReactCommon.QueryResult<IGetModalityConfigurationQuery, IGetModalityConfigurationQueryVariables>;
export const UpdateModalityConfigurationDocument = gql`
    mutation UpdateModalityConfiguration($updateModality: UpdateModalityConfigurationInput!) {
  updateModalityConfiguration(updatedModality: $updateModality) {
    ...ModalityConfigurationFragment
  }
}
    ${ModalityConfigurationFragmentFragmentDoc}`;
export type IUpdateModalityConfigurationMutationFn = ApolloReactCommon.MutationFunction<IUpdateModalityConfigurationMutation, IUpdateModalityConfigurationMutationVariables>;

/**
 * __useUpdateModalityConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateModalityConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModalityConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModalityConfigurationMutation, { data, loading, error }] = useUpdateModalityConfigurationMutation({
 *   variables: {
 *      updateModality: // value for 'updateModality'
 *   },
 * });
 */
export function useUpdateModalityConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpdateModalityConfigurationMutation, IUpdateModalityConfigurationMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpdateModalityConfigurationMutation, IUpdateModalityConfigurationMutationVariables>(UpdateModalityConfigurationDocument, baseOptions);
      }
export type UpdateModalityConfigurationMutationHookResult = ReturnType<typeof useUpdateModalityConfigurationMutation>;
export type UpdateModalityConfigurationMutationResult = ApolloReactCommon.MutationResult<IUpdateModalityConfigurationMutation>;
export type UpdateModalityConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpdateModalityConfigurationMutation, IUpdateModalityConfigurationMutationVariables>;
export const GetResponseTeamSettingsDocument = gql`
    query GetResponseTeamSettings($groupId: String!, $modalityId: String!, $filter: String = null, $sortBy: String = null, $top: Int, $skipToken: String = null) {
  responseTeamSettings(groupId: $groupId, modalityId: $modalityId, filter: $filter, sortBy: $sortBy, top: $top, skipToken: $skipToken) {
    items {
      ...ResponseTeamSettingFragment
    }
    pageInfo {
      skipToken
    }
  }
}
    ${ResponseTeamSettingFragmentFragmentDoc}`;

/**
 * __useGetResponseTeamSettingsQuery__
 *
 * To run a query within a React component, call `useGetResponseTeamSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponseTeamSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponseTeamSettingsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      modalityId: // value for 'modalityId'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      top: // value for 'top'
 *      skipToken: // value for 'skipToken'
 *   },
 * });
 */
export function useGetResponseTeamSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetResponseTeamSettingsQuery, IGetResponseTeamSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetResponseTeamSettingsQuery, IGetResponseTeamSettingsQueryVariables>(GetResponseTeamSettingsDocument, baseOptions);
      }
export function useGetResponseTeamSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetResponseTeamSettingsQuery, IGetResponseTeamSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetResponseTeamSettingsQuery, IGetResponseTeamSettingsQueryVariables>(GetResponseTeamSettingsDocument, baseOptions);
        }
export type GetResponseTeamSettingsQueryHookResult = ReturnType<typeof useGetResponseTeamSettingsQuery>;
export type GetResponseTeamSettingsLazyQueryHookResult = ReturnType<typeof useGetResponseTeamSettingsLazyQuery>;
export type GetResponseTeamSettingsQueryResult = ApolloReactCommon.QueryResult<IGetResponseTeamSettingsQuery, IGetResponseTeamSettingsQueryVariables>;
export const GetUserNotificationSettingsDocument = gql`
    query GetUserNotificationSettings($groupId: String!, $modalityId: String!, $filter: String = null, $sortBy: String = null, $top: Int, $skipToken: String = null) {
  userNotificationSettings(groupId: $groupId, modalityId: $modalityId, filter: $filter, sortBy: $sortBy, top: $top, skipToken: $skipToken) {
    items {
      ...UserNotificationSettingFragment
    }
    pageInfo {
      skipToken
    }
  }
}
    ${UserNotificationSettingFragmentFragmentDoc}`;

/**
 * __useGetUserNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationSettingsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      modalityId: // value for 'modalityId'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      top: // value for 'top'
 *      skipToken: // value for 'skipToken'
 *   },
 * });
 */
export function useGetUserNotificationSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserNotificationSettingsQuery, IGetUserNotificationSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserNotificationSettingsQuery, IGetUserNotificationSettingsQueryVariables>(GetUserNotificationSettingsDocument, baseOptions);
      }
export function useGetUserNotificationSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserNotificationSettingsQuery, IGetUserNotificationSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserNotificationSettingsQuery, IGetUserNotificationSettingsQueryVariables>(GetUserNotificationSettingsDocument, baseOptions);
        }
export type GetUserNotificationSettingsQueryHookResult = ReturnType<typeof useGetUserNotificationSettingsQuery>;
export type GetUserNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationSettingsLazyQuery>;
export type GetUserNotificationSettingsQueryResult = ApolloReactCommon.QueryResult<IGetUserNotificationSettingsQuery, IGetUserNotificationSettingsQueryVariables>;
export const GetUserProfilePicturesByIdsDocument = gql`
    query GetUserProfilePicturesByIds($ids: [String]!, $displayNames: [String]!) {
  userProfilePicturesByIds(ids: $ids, displayNames: $displayNames) {
    id
    value
  }
}
    `;

/**
 * __useGetUserProfilePicturesByIdsQuery__
 *
 * To run a query within a React component, call `useGetUserProfilePicturesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfilePicturesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfilePicturesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      displayNames: // value for 'displayNames'
 *   },
 * });
 */
export function useGetUserProfilePicturesByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserProfilePicturesByIdsQuery, IGetUserProfilePicturesByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserProfilePicturesByIdsQuery, IGetUserProfilePicturesByIdsQueryVariables>(GetUserProfilePicturesByIdsDocument, baseOptions);
      }
export function useGetUserProfilePicturesByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserProfilePicturesByIdsQuery, IGetUserProfilePicturesByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserProfilePicturesByIdsQuery, IGetUserProfilePicturesByIdsQueryVariables>(GetUserProfilePicturesByIdsDocument, baseOptions);
        }
export type GetUserProfilePicturesByIdsQueryHookResult = ReturnType<typeof useGetUserProfilePicturesByIdsQuery>;
export type GetUserProfilePicturesByIdsLazyQueryHookResult = ReturnType<typeof useGetUserProfilePicturesByIdsLazyQuery>;
export type GetUserProfilePicturesByIdsQueryResult = ApolloReactCommon.QueryResult<IGetUserProfilePicturesByIdsQuery, IGetUserProfilePicturesByIdsQueryVariables>;
export const GetResponseTeamSettingDocument = gql`
    query GetResponseTeamSetting($groupId: String!, $modalityId: String!, $userObjectId: String!) {
  responseTeamSetting(groupId: $groupId, modalityId: $modalityId, userObjectId: $userObjectId) {
    ...ResponseTeamSettingFragment
  }
}
    ${ResponseTeamSettingFragmentFragmentDoc}`;

/**
 * __useGetResponseTeamSettingQuery__
 *
 * To run a query within a React component, call `useGetResponseTeamSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponseTeamSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponseTeamSettingQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      modalityId: // value for 'modalityId'
 *      userObjectId: // value for 'userObjectId'
 *   },
 * });
 */
export function useGetResponseTeamSettingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetResponseTeamSettingQuery, IGetResponseTeamSettingQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetResponseTeamSettingQuery, IGetResponseTeamSettingQueryVariables>(GetResponseTeamSettingDocument, baseOptions);
      }
export function useGetResponseTeamSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetResponseTeamSettingQuery, IGetResponseTeamSettingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetResponseTeamSettingQuery, IGetResponseTeamSettingQueryVariables>(GetResponseTeamSettingDocument, baseOptions);
        }
export type GetResponseTeamSettingQueryHookResult = ReturnType<typeof useGetResponseTeamSettingQuery>;
export type GetResponseTeamSettingLazyQueryHookResult = ReturnType<typeof useGetResponseTeamSettingLazyQuery>;
export type GetResponseTeamSettingQueryResult = ApolloReactCommon.QueryResult<IGetResponseTeamSettingQuery, IGetResponseTeamSettingQueryVariables>;
export const GetUserNotificationSettingDocument = gql`
    query GetUserNotificationSetting($groupId: String!, $modalityId: String!, $userObjectId: String!) {
  userNotificationSetting(groupId: $groupId, modalityId: $modalityId, userObjectId: $userObjectId) {
    ...UserNotificationSettingFragment
  }
}
    ${UserNotificationSettingFragmentFragmentDoc}`;

/**
 * __useGetUserNotificationSettingQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationSettingQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      modalityId: // value for 'modalityId'
 *      userObjectId: // value for 'userObjectId'
 *   },
 * });
 */
export function useGetUserNotificationSettingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserNotificationSettingQuery, IGetUserNotificationSettingQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserNotificationSettingQuery, IGetUserNotificationSettingQueryVariables>(GetUserNotificationSettingDocument, baseOptions);
      }
export function useGetUserNotificationSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserNotificationSettingQuery, IGetUserNotificationSettingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserNotificationSettingQuery, IGetUserNotificationSettingQueryVariables>(GetUserNotificationSettingDocument, baseOptions);
        }
export type GetUserNotificationSettingQueryHookResult = ReturnType<typeof useGetUserNotificationSettingQuery>;
export type GetUserNotificationSettingLazyQueryHookResult = ReturnType<typeof useGetUserNotificationSettingLazyQuery>;
export type GetUserNotificationSettingQueryResult = ApolloReactCommon.QueryResult<IGetUserNotificationSettingQuery, IGetUserNotificationSettingQueryVariables>;
export const GetUsersByIdsDocument = gql`
    query GetUsersByIds($userIds: [String]!) {
  getUsersByIds(userIds: $userIds) {
    displayName
    id
    userPrincipalName
  }
}
    `;

/**
 * __useGetUsersByIdsQuery__
 *
 * To run a query within a React component, call `useGetUsersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByIdsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetUsersByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUsersByIdsQuery, IGetUsersByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUsersByIdsQuery, IGetUsersByIdsQueryVariables>(GetUsersByIdsDocument, baseOptions);
      }
export function useGetUsersByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUsersByIdsQuery, IGetUsersByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUsersByIdsQuery, IGetUsersByIdsQueryVariables>(GetUsersByIdsDocument, baseOptions);
        }
export type GetUsersByIdsQueryHookResult = ReturnType<typeof useGetUsersByIdsQuery>;
export type GetUsersByIdsLazyQueryHookResult = ReturnType<typeof useGetUsersByIdsLazyQuery>;
export type GetUsersByIdsQueryResult = ApolloReactCommon.QueryResult<IGetUsersByIdsQuery, IGetUsersByIdsQueryVariables>;
export const UpdateResponseTeamSettingsDocument = gql`
    mutation UpdateResponseTeamSettings($groupId: String!, $modalityId: String!, $userObjectId: String!, $updatedResponseTeamSettings: UpdateResponseTeamSettingsInput!) {
  updateResponseTeamSettings(groupId: $groupId, modalityId: $modalityId, userObjectId: $userObjectId, updatedResponseTeamSettings: $updatedResponseTeamSettings) {
    ...ResponseTeamSettingFragment
  }
}
    ${ResponseTeamSettingFragmentFragmentDoc}`;
export type IUpdateResponseTeamSettingsMutationFn = ApolloReactCommon.MutationFunction<IUpdateResponseTeamSettingsMutation, IUpdateResponseTeamSettingsMutationVariables>;

/**
 * __useUpdateResponseTeamSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateResponseTeamSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResponseTeamSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResponseTeamSettingsMutation, { data, loading, error }] = useUpdateResponseTeamSettingsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      modalityId: // value for 'modalityId'
 *      userObjectId: // value for 'userObjectId'
 *      updatedResponseTeamSettings: // value for 'updatedResponseTeamSettings'
 *   },
 * });
 */
export function useUpdateResponseTeamSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpdateResponseTeamSettingsMutation, IUpdateResponseTeamSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpdateResponseTeamSettingsMutation, IUpdateResponseTeamSettingsMutationVariables>(UpdateResponseTeamSettingsDocument, baseOptions);
      }
export type UpdateResponseTeamSettingsMutationHookResult = ReturnType<typeof useUpdateResponseTeamSettingsMutation>;
export type UpdateResponseTeamSettingsMutationResult = ApolloReactCommon.MutationResult<IUpdateResponseTeamSettingsMutation>;
export type UpdateResponseTeamSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpdateResponseTeamSettingsMutation, IUpdateResponseTeamSettingsMutationVariables>;
export const UpdateUserNotificationSettingsDocument = gql`
    mutation UpdateUserNotificationSettings($groupId: String!, $modalityId: String!, $userObjectId: String!, $updatedUserNotificationSettings: UpdateUserNotificationSettingsInput!) {
  updateUserNotificationSetting(groupId: $groupId, modalityId: $modalityId, userObjectId: $userObjectId, updatedUserNotificationSettings: $updatedUserNotificationSettings) {
    ...UserNotificationSettingFragment
  }
}
    ${UserNotificationSettingFragmentFragmentDoc}`;
export type IUpdateUserNotificationSettingsMutationFn = ApolloReactCommon.MutationFunction<IUpdateUserNotificationSettingsMutation, IUpdateUserNotificationSettingsMutationVariables>;

/**
 * __useUpdateUserNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationSettingsMutation, { data, loading, error }] = useUpdateUserNotificationSettingsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      modalityId: // value for 'modalityId'
 *      userObjectId: // value for 'userObjectId'
 *      updatedUserNotificationSettings: // value for 'updatedUserNotificationSettings'
 *   },
 * });
 */
export function useUpdateUserNotificationSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpdateUserNotificationSettingsMutation, IUpdateUserNotificationSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpdateUserNotificationSettingsMutation, IUpdateUserNotificationSettingsMutationVariables>(UpdateUserNotificationSettingsDocument, baseOptions);
      }
export type UpdateUserNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateUserNotificationSettingsMutation>;
export type UpdateUserNotificationSettingsMutationResult = ApolloReactCommon.MutationResult<IUpdateUserNotificationSettingsMutation>;
export type UpdateUserNotificationSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpdateUserNotificationSettingsMutation, IUpdateUserNotificationSettingsMutationVariables>;
export const SearchTeamMembersDocument = gql`
    query SearchTeamMembers($teamId: String!, $top: Int!, $search: String!) {
  searchTeamMembers(teamId: $teamId, top: $top, search: $search) {
    userPrincipalName
    displayName
    id
  }
}
    `;

/**
 * __useSearchTeamMembersQuery__
 *
 * To run a query within a React component, call `useSearchTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTeamMembersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      top: // value for 'top'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchTeamMembersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISearchTeamMembersQuery, ISearchTeamMembersQueryVariables>) {
        return ApolloReactHooks.useQuery<ISearchTeamMembersQuery, ISearchTeamMembersQueryVariables>(SearchTeamMembersDocument, baseOptions);
      }
export function useSearchTeamMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISearchTeamMembersQuery, ISearchTeamMembersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISearchTeamMembersQuery, ISearchTeamMembersQueryVariables>(SearchTeamMembersDocument, baseOptions);
        }
export type SearchTeamMembersQueryHookResult = ReturnType<typeof useSearchTeamMembersQuery>;
export type SearchTeamMembersLazyQueryHookResult = ReturnType<typeof useSearchTeamMembersLazyQuery>;
export type SearchTeamMembersQueryResult = ApolloReactCommon.QueryResult<ISearchTeamMembersQuery, ISearchTeamMembersQueryVariables>;
export const EnsureRecipientPermissionIsSetDocument = gql`
    query EnsureRecipientPermissionIsSet($modernGroupSmtp: String!, $userSmtp: String!) {
  ensureRecipientPermissionIsSet(modernGroupSmtp: $modernGroupSmtp, userSmtp: $userSmtp)
}
    `;

/**
 * __useEnsureRecipientPermissionIsSetQuery__
 *
 * To run a query within a React component, call `useEnsureRecipientPermissionIsSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnsureRecipientPermissionIsSetQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnsureRecipientPermissionIsSetQuery({
 *   variables: {
 *      modernGroupSmtp: // value for 'modernGroupSmtp'
 *      userSmtp: // value for 'userSmtp'
 *   },
 * });
 */
export function useEnsureRecipientPermissionIsSetQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IEnsureRecipientPermissionIsSetQuery, IEnsureRecipientPermissionIsSetQueryVariables>) {
        return ApolloReactHooks.useQuery<IEnsureRecipientPermissionIsSetQuery, IEnsureRecipientPermissionIsSetQueryVariables>(EnsureRecipientPermissionIsSetDocument, baseOptions);
      }
export function useEnsureRecipientPermissionIsSetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IEnsureRecipientPermissionIsSetQuery, IEnsureRecipientPermissionIsSetQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IEnsureRecipientPermissionIsSetQuery, IEnsureRecipientPermissionIsSetQueryVariables>(EnsureRecipientPermissionIsSetDocument, baseOptions);
        }
export type EnsureRecipientPermissionIsSetQueryHookResult = ReturnType<typeof useEnsureRecipientPermissionIsSetQuery>;
export type EnsureRecipientPermissionIsSetLazyQueryHookResult = ReturnType<typeof useEnsureRecipientPermissionIsSetLazyQuery>;
export type EnsureRecipientPermissionIsSetQueryResult = ApolloReactCommon.QueryResult<IEnsureRecipientPermissionIsSetQuery, IEnsureRecipientPermissionIsSetQueryVariables>;
export const GetChannelModalitiesDocument = gql`
    query GetChannelModalities($groupId: String!, $channelId: String!) {
  channelModalities(groupId: $groupId, channelId: $channelId) {
    items {
      ...ModalityConfigurationFragment
    }
  }
}
    ${ModalityConfigurationFragmentFragmentDoc}`;

/**
 * __useGetChannelModalitiesQuery__
 *
 * To run a query within a React component, call `useGetChannelModalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelModalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelModalitiesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelModalitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetChannelModalitiesQuery, IGetChannelModalitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetChannelModalitiesQuery, IGetChannelModalitiesQueryVariables>(GetChannelModalitiesDocument, baseOptions);
      }
export function useGetChannelModalitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetChannelModalitiesQuery, IGetChannelModalitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetChannelModalitiesQuery, IGetChannelModalitiesQueryVariables>(GetChannelModalitiesDocument, baseOptions);
        }
export type GetChannelModalitiesQueryHookResult = ReturnType<typeof useGetChannelModalitiesQuery>;
export type GetChannelModalitiesLazyQueryHookResult = ReturnType<typeof useGetChannelModalitiesLazyQuery>;
export type GetChannelModalitiesQueryResult = ApolloReactCommon.QueryResult<IGetChannelModalitiesQuery, IGetChannelModalitiesQueryVariables>;
export const GetSendAsStateDocument = gql`
    query GetSendAsState {
  sendAsState @client {
    timeSet
  }
}
    `;

/**
 * __useGetSendAsStateQuery__
 *
 * To run a query within a React component, call `useGetSendAsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendAsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendAsStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSendAsStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSendAsStateQuery, IGetSendAsStateQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSendAsStateQuery, IGetSendAsStateQueryVariables>(GetSendAsStateDocument, baseOptions);
      }
export function useGetSendAsStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSendAsStateQuery, IGetSendAsStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSendAsStateQuery, IGetSendAsStateQueryVariables>(GetSendAsStateDocument, baseOptions);
        }
export type GetSendAsStateQueryHookResult = ReturnType<typeof useGetSendAsStateQuery>;
export type GetSendAsStateLazyQueryHookResult = ReturnType<typeof useGetSendAsStateLazyQuery>;
export type GetSendAsStateQueryResult = ApolloReactCommon.QueryResult<IGetSendAsStateQuery, IGetSendAsStateQueryVariables>;
export const SetSendAsStateDocument = gql`
    mutation SetSendAsState($sendAsState: SendAsStateInput!) {
  setSendAsState(sendAsState: $sendAsState) @client {
    timeSet
  }
}
    `;
export type ISetSendAsStateMutationFn = ApolloReactCommon.MutationFunction<ISetSendAsStateMutation, ISetSendAsStateMutationVariables>;

/**
 * __useSetSendAsStateMutation__
 *
 * To run a mutation, you first call `useSetSendAsStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSendAsStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSendAsStateMutation, { data, loading, error }] = useSetSendAsStateMutation({
 *   variables: {
 *      sendAsState: // value for 'sendAsState'
 *   },
 * });
 */
export function useSetSendAsStateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISetSendAsStateMutation, ISetSendAsStateMutationVariables>) {
        return ApolloReactHooks.useMutation<ISetSendAsStateMutation, ISetSendAsStateMutationVariables>(SetSendAsStateDocument, baseOptions);
      }
export type SetSendAsStateMutationHookResult = ReturnType<typeof useSetSendAsStateMutation>;
export type SetSendAsStateMutationResult = ApolloReactCommon.MutationResult<ISetSendAsStateMutation>;
export type SetSendAsStateMutationOptions = ApolloReactCommon.BaseMutationOptions<ISetSendAsStateMutation, ISetSendAsStateMutationVariables>;
export const CreateTicketDocument = gql`
    mutation CreateTicket($groupId: String!, $channelId: String!, $newTicket: CreateTicketInput!) {
  createTicket(groupId: $groupId, channelId: $channelId, newTicket: $newTicket) {
    id
    title
    customerDisplayName
    customerAddress
    assignedToObjectId
    assignedToDisplayName
    state
    lastModifiedDateTime
    createdDateTime
  }
}
    `;
export type ICreateTicketMutationFn = ApolloReactCommon.MutationFunction<ICreateTicketMutation, ICreateTicketMutationVariables>;

/**
 * __useCreateTicketMutation__
 *
 * To run a mutation, you first call `useCreateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketMutation, { data, loading, error }] = useCreateTicketMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      newTicket: // value for 'newTicket'
 *   },
 * });
 */
export function useCreateTicketMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateTicketMutation, ICreateTicketMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateTicketMutation, ICreateTicketMutationVariables>(CreateTicketDocument, baseOptions);
      }
export type CreateTicketMutationHookResult = ReturnType<typeof useCreateTicketMutation>;
export type CreateTicketMutationResult = ApolloReactCommon.MutationResult<ICreateTicketMutation>;
export type CreateTicketMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateTicketMutation, ICreateTicketMutationVariables>;
export const GetEmailsByTicketIdDocument = gql`
    query GetEmailsByTicketId($groupId: String!, $ticketId: String!, $top: Int = 1) {
  getEmailsByTicketId(groupId: $groupId, ticketId: $ticketId, top: $top) {
    id
    conversationId
    internetMessageId
    hasAttachments
    from {
      emailAddress {
        address
        name
      }
    }
    toRecipients {
      emailAddress {
        address
        name
      }
    }
    receivedDateTime
    subject
    bodyPreview
    body {
      content
      contentType
    }
  }
}
    `;

/**
 * __useGetEmailsByTicketIdQuery__
 *
 * To run a query within a React component, call `useGetEmailsByTicketIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailsByTicketIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailsByTicketIdQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      ticketId: // value for 'ticketId'
 *      top: // value for 'top'
 *   },
 * });
 */
export function useGetEmailsByTicketIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetEmailsByTicketIdQuery, IGetEmailsByTicketIdQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetEmailsByTicketIdQuery, IGetEmailsByTicketIdQueryVariables>(GetEmailsByTicketIdDocument, baseOptions);
      }
export function useGetEmailsByTicketIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetEmailsByTicketIdQuery, IGetEmailsByTicketIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetEmailsByTicketIdQuery, IGetEmailsByTicketIdQueryVariables>(GetEmailsByTicketIdDocument, baseOptions);
        }
export type GetEmailsByTicketIdQueryHookResult = ReturnType<typeof useGetEmailsByTicketIdQuery>;
export type GetEmailsByTicketIdLazyQueryHookResult = ReturnType<typeof useGetEmailsByTicketIdLazyQuery>;
export type GetEmailsByTicketIdQueryResult = ApolloReactCommon.QueryResult<IGetEmailsByTicketIdQuery, IGetEmailsByTicketIdQueryVariables>;
export const GetGroupDocument = gql`
    query GetGroup($groupId: String!) {
  getGroup(groupId: $groupId) {
    id
    emailAddress
  }
}
    `;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetGroupQuery, IGetGroupQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetGroupQuery, IGetGroupQueryVariables>(GetGroupDocument, baseOptions);
      }
export function useGetGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetGroupQuery, IGetGroupQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetGroupQuery, IGetGroupQueryVariables>(GetGroupDocument, baseOptions);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = ApolloReactCommon.QueryResult<IGetGroupQuery, IGetGroupQueryVariables>;
export const RespondToEmailDocument = gql`
    mutation RespondToEmail($itemId: String!, $groupId: String!, $action: EmailResponseActions!) {
  respondToEmail(itemId: $itemId, groupId: $groupId, action: $action)
}
    `;
export type IRespondToEmailMutationFn = ApolloReactCommon.MutationFunction<IRespondToEmailMutation, IRespondToEmailMutationVariables>;

/**
 * __useRespondToEmailMutation__
 *
 * To run a mutation, you first call `useRespondToEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToEmailMutation, { data, loading, error }] = useRespondToEmailMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      groupId: // value for 'groupId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useRespondToEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IRespondToEmailMutation, IRespondToEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<IRespondToEmailMutation, IRespondToEmailMutationVariables>(RespondToEmailDocument, baseOptions);
      }
export type RespondToEmailMutationHookResult = ReturnType<typeof useRespondToEmailMutation>;
export type RespondToEmailMutationResult = ApolloReactCommon.MutationResult<IRespondToEmailMutation>;
export type RespondToEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<IRespondToEmailMutation, IRespondToEmailMutationVariables>;
export const UpdateTicketDocument = gql`
    mutation UpdateTicket($groupId: String!, $channelId: String!, $ticketId: String!, $updatedTicket: UpdateTicketInput!) {
  updateTicket(groupId: $groupId, channelId: $channelId, ticketId: $ticketId, updatedTicket: $updatedTicket) {
    id
    title
    customerDisplayName
    customerAddress
    assignedToObjectId
    assignedToDisplayName
    state
    lastModifiedDateTime
    createdDateTime
    teamsConversationId
  }
}
    `;
export type IUpdateTicketMutationFn = ApolloReactCommon.MutationFunction<IUpdateTicketMutation, IUpdateTicketMutationVariables>;

/**
 * __useUpdateTicketMutation__
 *
 * To run a mutation, you first call `useUpdateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketMutation, { data, loading, error }] = useUpdateTicketMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      ticketId: // value for 'ticketId'
 *      updatedTicket: // value for 'updatedTicket'
 *   },
 * });
 */
export function useUpdateTicketMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpdateTicketMutation, IUpdateTicketMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpdateTicketMutation, IUpdateTicketMutationVariables>(UpdateTicketDocument, baseOptions);
      }
export type UpdateTicketMutationHookResult = ReturnType<typeof useUpdateTicketMutation>;
export type UpdateTicketMutationResult = ApolloReactCommon.MutationResult<IUpdateTicketMutation>;
export type UpdateTicketMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpdateTicketMutation, IUpdateTicketMutationVariables>;
export const GetTicketActivitiesDocument = gql`
    query GetTicketActivities($groupId: String!, $channelId: String!, $ticketId: String!, $filter: String = null, $sortBy: String = null, $top: Int = 50, $skipToken: String = null) {
  ticketActivities(groupId: $groupId, channelId: $channelId, ticketId: $ticketId, filter: $filter, sortBy: $sortBy, top: $top, skipToken: $skipToken) {
    items {
      actionType
      actorId
      actorName
      actionTime
      createdDateTime
      delta {
        currentValue
        previousValue
        propertyPath
      }
      eTag
      id
      lastModifiedDateTime
      ticketId
      type
    }
    pageInfo {
      nextLink
      skipToken
    }
  }
}
    `;

/**
 * __useGetTicketActivitiesQuery__
 *
 * To run a query within a React component, call `useGetTicketActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketActivitiesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      ticketId: // value for 'ticketId'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      top: // value for 'top'
 *      skipToken: // value for 'skipToken'
 *   },
 * });
 */
export function useGetTicketActivitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetTicketActivitiesQuery, IGetTicketActivitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetTicketActivitiesQuery, IGetTicketActivitiesQueryVariables>(GetTicketActivitiesDocument, baseOptions);
      }
export function useGetTicketActivitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetTicketActivitiesQuery, IGetTicketActivitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetTicketActivitiesQuery, IGetTicketActivitiesQueryVariables>(GetTicketActivitiesDocument, baseOptions);
        }
export type GetTicketActivitiesQueryHookResult = ReturnType<typeof useGetTicketActivitiesQuery>;
export type GetTicketActivitiesLazyQueryHookResult = ReturnType<typeof useGetTicketActivitiesLazyQuery>;
export type GetTicketActivitiesQueryResult = ApolloReactCommon.QueryResult<IGetTicketActivitiesQuery, IGetTicketActivitiesQueryVariables>;
export const SetTicketListSelectionStateDocument = gql`
    mutation SetTicketListSelectionState($state: TicketListSelectionStateInput!) {
  setTicketListSelectionState(state: $state) @client {
    selectedTicketIdsList
  }
}
    `;
export type ISetTicketListSelectionStateMutationFn = ApolloReactCommon.MutationFunction<ISetTicketListSelectionStateMutation, ISetTicketListSelectionStateMutationVariables>;

/**
 * __useSetTicketListSelectionStateMutation__
 *
 * To run a mutation, you first call `useSetTicketListSelectionStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTicketListSelectionStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTicketListSelectionStateMutation, { data, loading, error }] = useSetTicketListSelectionStateMutation({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSetTicketListSelectionStateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISetTicketListSelectionStateMutation, ISetTicketListSelectionStateMutationVariables>) {
        return ApolloReactHooks.useMutation<ISetTicketListSelectionStateMutation, ISetTicketListSelectionStateMutationVariables>(SetTicketListSelectionStateDocument, baseOptions);
      }
export type SetTicketListSelectionStateMutationHookResult = ReturnType<typeof useSetTicketListSelectionStateMutation>;
export type SetTicketListSelectionStateMutationResult = ApolloReactCommon.MutationResult<ISetTicketListSelectionStateMutation>;
export type SetTicketListSelectionStateMutationOptions = ApolloReactCommon.BaseMutationOptions<ISetTicketListSelectionStateMutation, ISetTicketListSelectionStateMutationVariables>;
export const SetTicketListStateDocument = gql`
    mutation SetTicketListState($state: TicketListStateInput!) {
  setTicketListState(state: $state) @client {
    ...TicketListStateFragment
  }
}
    ${TicketListStateFragmentFragmentDoc}`;
export type ISetTicketListStateMutationFn = ApolloReactCommon.MutationFunction<ISetTicketListStateMutation, ISetTicketListStateMutationVariables>;

/**
 * __useSetTicketListStateMutation__
 *
 * To run a mutation, you first call `useSetTicketListStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTicketListStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTicketListStateMutation, { data, loading, error }] = useSetTicketListStateMutation({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSetTicketListStateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISetTicketListStateMutation, ISetTicketListStateMutationVariables>) {
        return ApolloReactHooks.useMutation<ISetTicketListStateMutation, ISetTicketListStateMutationVariables>(SetTicketListStateDocument, baseOptions);
      }
export type SetTicketListStateMutationHookResult = ReturnType<typeof useSetTicketListStateMutation>;
export type SetTicketListStateMutationResult = ApolloReactCommon.MutationResult<ISetTicketListStateMutation>;
export type SetTicketListStateMutationOptions = ApolloReactCommon.BaseMutationOptions<ISetTicketListStateMutation, ISetTicketListStateMutationVariables>;
export const GetTicketDocument = gql`
    query GetTicket($groupId: String!, $channelId: String!, $ticketId: String!) {
  ticket(groupId: $groupId, channelId: $channelId, ticketId: $ticketId) {
    id
    itemId
    groupId
    channelId
    title
    createdDateTime
    itemId
    customerDisplayName
    customerAddress
    assignedToObjectId
    assignedToDisplayName
    state
    lastModifiedDateTime
    lastCommunicationAt
    createdBy
    teamsConversationId
    isFollowing
  }
}
    `;

/**
 * __useGetTicketQuery__
 *
 * To run a query within a React component, call `useGetTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetTicketQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetTicketQuery, IGetTicketQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetTicketQuery, IGetTicketQueryVariables>(GetTicketDocument, baseOptions);
      }
export function useGetTicketLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetTicketQuery, IGetTicketQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetTicketQuery, IGetTicketQueryVariables>(GetTicketDocument, baseOptions);
        }
export type GetTicketQueryHookResult = ReturnType<typeof useGetTicketQuery>;
export type GetTicketLazyQueryHookResult = ReturnType<typeof useGetTicketLazyQuery>;
export type GetTicketQueryResult = ApolloReactCommon.QueryResult<IGetTicketQuery, IGetTicketQueryVariables>;
export const GetTicketListDocument = gql`
    query GetTicketList($groupId: String!, $channelId: String!, $filter: String, $sortBy: String, $top: Int!, $skipToken: String) {
  tickets(groupId: $groupId, channelId: $channelId, filter: $filter, sortBy: $sortBy, top: $top, skipToken: $skipToken) {
    items {
      id
      itemId
      groupId
      channelId
      title
      createdDateTime
      itemId
      customerDisplayName
      customerAddress
      assignedToObjectId
      assignedToDisplayName
      state
      lastModifiedDateTime
      lastCommunicationAt
      createdBy
      teamsConversationId
      isFollowing
    }
    pageInfo {
      nextLink
      skipToken
    }
  }
}
    `;

/**
 * __useGetTicketListQuery__
 *
 * To run a query within a React component, call `useGetTicketListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketListQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketListQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      top: // value for 'top'
 *      skipToken: // value for 'skipToken'
 *   },
 * });
 */
export function useGetTicketListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetTicketListQuery, IGetTicketListQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetTicketListQuery, IGetTicketListQueryVariables>(GetTicketListDocument, baseOptions);
      }
export function useGetTicketListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetTicketListQuery, IGetTicketListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetTicketListQuery, IGetTicketListQueryVariables>(GetTicketListDocument, baseOptions);
        }
export type GetTicketListQueryHookResult = ReturnType<typeof useGetTicketListQuery>;
export type GetTicketListLazyQueryHookResult = ReturnType<typeof useGetTicketListLazyQuery>;
export type GetTicketListQueryResult = ApolloReactCommon.QueryResult<IGetTicketListQuery, IGetTicketListQueryVariables>;
export const GetTicketListSelectionStateDocument = gql`
    query GetTicketListSelectionState {
  ticketListSelectionState @client {
    selectedTicketIdsList
  }
}
    `;

/**
 * __useGetTicketListSelectionStateQuery__
 *
 * To run a query within a React component, call `useGetTicketListSelectionStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketListSelectionStateQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketListSelectionStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTicketListSelectionStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetTicketListSelectionStateQuery, IGetTicketListSelectionStateQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetTicketListSelectionStateQuery, IGetTicketListSelectionStateQueryVariables>(GetTicketListSelectionStateDocument, baseOptions);
      }
export function useGetTicketListSelectionStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetTicketListSelectionStateQuery, IGetTicketListSelectionStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetTicketListSelectionStateQuery, IGetTicketListSelectionStateQueryVariables>(GetTicketListSelectionStateDocument, baseOptions);
        }
export type GetTicketListSelectionStateQueryHookResult = ReturnType<typeof useGetTicketListSelectionStateQuery>;
export type GetTicketListSelectionStateLazyQueryHookResult = ReturnType<typeof useGetTicketListSelectionStateLazyQuery>;
export type GetTicketListSelectionStateQueryResult = ApolloReactCommon.QueryResult<IGetTicketListSelectionStateQuery, IGetTicketListSelectionStateQueryVariables>;
export const GetTicketListStateDocument = gql`
    query GetTicketListState {
  ticketListState @client {
    ...TicketListStateFragment
  }
}
    ${TicketListStateFragmentFragmentDoc}`;

/**
 * __useGetTicketListStateQuery__
 *
 * To run a query within a React component, call `useGetTicketListStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketListStateQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketListStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTicketListStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetTicketListStateQuery, IGetTicketListStateQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetTicketListStateQuery, IGetTicketListStateQueryVariables>(GetTicketListStateDocument, baseOptions);
      }
export function useGetTicketListStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetTicketListStateQuery, IGetTicketListStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetTicketListStateQuery, IGetTicketListStateQueryVariables>(GetTicketListStateDocument, baseOptions);
        }
export type GetTicketListStateQueryHookResult = ReturnType<typeof useGetTicketListStateQuery>;
export type GetTicketListStateLazyQueryHookResult = ReturnType<typeof useGetTicketListStateLazyQuery>;
export type GetTicketListStateQueryResult = ApolloReactCommon.QueryResult<IGetTicketListStateQuery, IGetTicketListStateQueryVariables>;
export const GetTicketListWatermarkDocument = gql`
    query GetTicketListWatermark($groupId: String!, $channelId: String!, $lastKnownDateTime: String = null) {
  ticketsWatermark(groupId: $groupId, channelId: $channelId, lastKnownDateTime: $lastKnownDateTime)
}
    `;

/**
 * __useGetTicketListWatermarkQuery__
 *
 * To run a query within a React component, call `useGetTicketListWatermarkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketListWatermarkQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketListWatermarkQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      lastKnownDateTime: // value for 'lastKnownDateTime'
 *   },
 * });
 */
export function useGetTicketListWatermarkQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetTicketListWatermarkQuery, IGetTicketListWatermarkQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetTicketListWatermarkQuery, IGetTicketListWatermarkQueryVariables>(GetTicketListWatermarkDocument, baseOptions);
      }
export function useGetTicketListWatermarkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetTicketListWatermarkQuery, IGetTicketListWatermarkQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetTicketListWatermarkQuery, IGetTicketListWatermarkQueryVariables>(GetTicketListWatermarkDocument, baseOptions);
        }
export type GetTicketListWatermarkQueryHookResult = ReturnType<typeof useGetTicketListWatermarkQuery>;
export type GetTicketListWatermarkLazyQueryHookResult = ReturnType<typeof useGetTicketListWatermarkLazyQuery>;
export type GetTicketListWatermarkQueryResult = ApolloReactCommon.QueryResult<IGetTicketListWatermarkQuery, IGetTicketListWatermarkQueryVariables>;
export const GetUserProfilePicturesDocument = gql`
    query GetUserProfilePictures($ids: [String]!, $displayNames: [String]!) {
  userProfilePicturesByIds(ids: $ids, displayNames: $displayNames) @connection(key: "userProfilePicturesByIds", filter: ["ids"]) {
    id
    value
  }
}
    `;

/**
 * __useGetUserProfilePicturesQuery__
 *
 * To run a query within a React component, call `useGetUserProfilePicturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfilePicturesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfilePicturesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      displayNames: // value for 'displayNames'
 *   },
 * });
 */
export function useGetUserProfilePicturesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserProfilePicturesQuery, IGetUserProfilePicturesQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserProfilePicturesQuery, IGetUserProfilePicturesQueryVariables>(GetUserProfilePicturesDocument, baseOptions);
      }
export function useGetUserProfilePicturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserProfilePicturesQuery, IGetUserProfilePicturesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserProfilePicturesQuery, IGetUserProfilePicturesQueryVariables>(GetUserProfilePicturesDocument, baseOptions);
        }
export type GetUserProfilePicturesQueryHookResult = ReturnType<typeof useGetUserProfilePicturesQuery>;
export type GetUserProfilePicturesLazyQueryHookResult = ReturnType<typeof useGetUserProfilePicturesLazyQuery>;
export type GetUserProfilePicturesQueryResult = ApolloReactCommon.QueryResult<IGetUserProfilePicturesQuery, IGetUserProfilePicturesQueryVariables>;
export const GetUserSettingsDocument = gql`
    query GetUserSettings {
  userSettings @client {
    hideFirstRunExperience
  }
}
    `;

/**
 * __useGetUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserSettingsQuery, IGetUserSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserSettingsQuery, IGetUserSettingsQueryVariables>(GetUserSettingsDocument, baseOptions);
      }
export function useGetUserSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserSettingsQuery, IGetUserSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserSettingsQuery, IGetUserSettingsQueryVariables>(GetUserSettingsDocument, baseOptions);
        }
export type GetUserSettingsQueryHookResult = ReturnType<typeof useGetUserSettingsQuery>;
export type GetUserSettingsLazyQueryHookResult = ReturnType<typeof useGetUserSettingsLazyQuery>;
export type GetUserSettingsQueryResult = ApolloReactCommon.QueryResult<IGetUserSettingsQuery, IGetUserSettingsQueryVariables>;
export const UpdateTicketsDocument = gql`
    mutation UpdateTickets($groupId: String!, $channelId: String!, $ticketIds: [String]!, $updatedTickets: [UpdateTicketInput]!) {
  updateTickets(groupId: $groupId, channelId: $channelId, ticketIds: $ticketIds, updatedTickets: $updatedTickets) {
    id
    title
    customerDisplayName
    customerAddress
    assignedToObjectId
    assignedToDisplayName
    state
    lastModifiedDateTime
    createdDateTime
    teamsConversationId
  }
}
    `;
export type IUpdateTicketsMutationFn = ApolloReactCommon.MutationFunction<IUpdateTicketsMutation, IUpdateTicketsMutationVariables>;

/**
 * __useUpdateTicketsMutation__
 *
 * To run a mutation, you first call `useUpdateTicketsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketsMutation, { data, loading, error }] = useUpdateTicketsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      channelId: // value for 'channelId'
 *      ticketIds: // value for 'ticketIds'
 *      updatedTickets: // value for 'updatedTickets'
 *   },
 * });
 */
export function useUpdateTicketsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpdateTicketsMutation, IUpdateTicketsMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpdateTicketsMutation, IUpdateTicketsMutationVariables>(UpdateTicketsDocument, baseOptions);
      }
export type UpdateTicketsMutationHookResult = ReturnType<typeof useUpdateTicketsMutation>;
export type UpdateTicketsMutationResult = ApolloReactCommon.MutationResult<IUpdateTicketsMutation>;
export type UpdateTicketsMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpdateTicketsMutation, IUpdateTicketsMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation UpdateUserSettings($userSettings: UserSettingsInput!) {
  setUserSettings(userSettings: $userSettings) @client {
    hideFirstRunExperience
  }
}
    `;
export type IUpdateUserSettingsMutationFn = ApolloReactCommon.MutationFunction<IUpdateUserSettingsMutation, IUpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      userSettings: // value for 'userSettings'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpdateUserSettingsMutation, IUpdateUserSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpdateUserSettingsMutation, IUpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, baseOptions);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = ApolloReactCommon.MutationResult<IUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpdateUserSettingsMutation, IUpdateUserSettingsMutationVariables>;
export const GetAriaKeyDocument = gql`
    query GetAriaKey($clientType: AriaKeyClientType!) {
  getAriaKey(clientType: $clientType)
}
    `;

/**
 * __useGetAriaKeyQuery__
 *
 * To run a query within a React component, call `useGetAriaKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAriaKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAriaKeyQuery({
 *   variables: {
 *      clientType: // value for 'clientType'
 *   },
 * });
 */
export function useGetAriaKeyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetAriaKeyQuery, IGetAriaKeyQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetAriaKeyQuery, IGetAriaKeyQueryVariables>(GetAriaKeyDocument, baseOptions);
      }
export function useGetAriaKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetAriaKeyQuery, IGetAriaKeyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetAriaKeyQuery, IGetAriaKeyQueryVariables>(GetAriaKeyDocument, baseOptions);
        }
export type GetAriaKeyQueryHookResult = ReturnType<typeof useGetAriaKeyQuery>;
export type GetAriaKeyLazyQueryHookResult = ReturnType<typeof useGetAriaKeyLazyQuery>;
export type GetAriaKeyQueryResult = ApolloReactCommon.QueryResult<IGetAriaKeyQuery, IGetAriaKeyQueryVariables>;